
const translations = {
    "Notice!": "Увага!",
    "Are you sure that you want to delete this?": "Ви впевнені, що хочете це видалити?",
    "Confirm": "Підтвердити",
    "Cancel": "Скасувати",
    "Min": "Мін",
    "Max": "Макс",
    "Before": "До",
    "After": "Після",
    "w": "н",
    "week": "тиждень",
    "weeks": "тижні",
    "d": "д",
    "day": "день",
    "days": "днів",
    "Due date": "Термін виконання",
    "Start date": "Дата початку",
    "Internal date": "Внутрішня дата",
    "Notes": "Нотатки",
    "Document": "Документ",
    "Email": "Email",
    "Billing": "Білінг",
    "Add": "Додати",
    "Archived": "Архівовано",
    "Cancelled": "Скасовано",
    "Active": "Активний",
    "Inactive": "Неактивний",
    "Client company": "Компанія-клієнт",
    "General info": "Загальна інформація",
    "Digitisation of client documents": "Оцифрування клієнтських документів",
    "Client portal": "WorkWeb",
    "Documents": "Документи",
    "Members": "Учасники",
    "Preferences": "Вподобання",
    "Yes": "Так",
    "No": "Ні",
    "Total hours": "Загальна кількість годин",
    "Extra hours": "Додаткові години",
    "Client": "Клієнт",
    "Tasks": "Завдання",
    "Disable Uku’s task templates": "Вимкніть шаблони завдань Уку",
    "Set the estimation as time when the exact value is not entered": "Встановіть оцінку як час, коли точне значення не введено",
    "Checklist must be completed to finish the task": "Чек-лист необхідно виконати, щоб виконати завдання",
    "Disable topic management for members": "Як вимкнути керування темами для учасників",
    "Disable time edit for members": "Як вимкнути редагування часу для учасників",
    "Allow time entries in future": "Дозволити записи часу в майбутньому",
    "Show all dependent tasks in the calendar": "Show all dependent tasks in the calendar",
    "Clients": "Клієнти",
    "Disable adding new clients for members": "Вимкніть додавання нових клієнтів для учасників",
    "Only administrators can edit documents": "Редагувати документи можуть лише адміністратори",
    "Allow digitisation of client documents": "Дозвольте оцифровувати документи клієнтів",
    "Use my Microsoft account": "Використання мого облікового запису Microsoft",
    "Disconnect my Microsoft account": "Відключення облікового запису Microsoft",
    "Connect my Microsoft account": "Підключення облікового запису Microsoft",
    "Use my google account": "Як користуватися моїм обліковим записом Google",
    "Connect my google account": "Як підключити обліковий запис Google",
    "Disconnect my google account": "Як відключити обліковий запис Google",
    "Use my Xero account": "Use my Xero account",
    "Connect my Xero account": "Connect my Xero account",
    "Disconnect my Xero account": "Disconnect my Xero account",
    "Emails": "Електронні адреси",
    "Daily agenda": "Щоденний порядок денний",
    "Unread notifications": "Непрочитані повідомлення",
    "Task assigned to me": "Поставлене мені завдання",
    "Weekly summary": "Підсумки тижня",
    "Monthly summary": "Підсумки місяця",
    "Updates and tips": "Оновлення та поради",
    "Overdue": "Прострочений",
    "1 day": "1 день",
    "1 day overdue": "1 день прострочення",
    "{0} days": "{0} днів",
    "{0} days overdue": "{0} днів прострочення",
    "{0} minute ago": "{0} хвилину тому",
    "{0} minutes ago": "{0} хвилин тому",
    "{0} hour ago": "{0} годину тому",
    "{0} hours ago": "{0} годин тому",
    "Sunday": "Неділя",
    "Monday": "Понеділок",
    "Tuesday": "Вівторок",
    "Wednesday": "Середа",
    "Thursday": "Четвер",
    "Friday": "П'ятниця",
    "Saturday": "Субота",
    "Sun": "Нд",
    "Mon": "Пон",
    "Tue": "Вт",
    "Wed": "Ср",
    "Thu": "Чт",
    "Fri": "Пт",
    "Sat": "Сб",
    "January": "Січень",
    "February": "Лютий",
    "March": "Березень",
    "April": "Квітень",
    "May": "Травень",
    "June": "Червень",
    "July": "Липень",
    "August": "Серпень",
    "September": "Вересень",
    "October": "Жовтень",
    "November": "Листопад",
    "December": "Грудень",
    "Jan": "Січ",
    "Feb": "Лют",
    "Mar": "Бер",
    "Apr": "Квіт",
    "Jun": "Черв",
    "Jul": "Лип",
    "Aug": "Серп",
    "Sep": "Вер",
    "Oct": "Жов",
    "Nov": "Лис",
    "Dec": "Гру",
    "Today": "Сьогодні",
    "Yesterday": "Вчора",
    "Day": "День",
    "Days": "Дні",
    "+{0} d": "+{0} d",
    "+{0} wd": "+{0} WD",
    "Weekly {0}": "Щотижневий {0}",
    "Every {0}. week {1}": "Кожен {0}. тиждень {1}",
    "{0}": "{0}",
    "Monthly {0}. d": "Щомісячна {0}. d",
    "Every {0}. month {1}. d": "Кожен {0}. місяць {1}. d",
    "{0}. d": "{0}. д",
    "Quarterly {0}. month {1}. d": "Квартальний {0}. місяць {1}. d",
    "Every {0}. quarter {1}. month {2}. d": "Кожен {0}. чверть {1}. місяць {2}. d",
    "{0}. month {1}. d": "{0}. місяць {1}. d",
    "Yearly {0}": "Щорічна {0}",
    "Every {0}. year {1}": "Кожен {0}. рік {1}",
    "Mo": "Пн",
    "Tu": "Вт",
    "We": "Ср",
    "Th": "Чт",
    "Fr": "Пт",
    "Sa": "Сб",
    "Su": "Нд",
    "and": "та",
    "{0}w": "{0}w",
    "{0}d": "{0}d",
    "before": "до",
    "after": "після",
    "Project": "Проект",
    "Quarter": "Чверть",
    "Add logo": "Add logo",
    "Add your photo": "Додайте свою фотографію",
    "Adding file failed": "Помилка додавання файлу",
    "Please check the file.": "Будь ласка, перевірте файл.",
    "You can only add pictures.": "Можна лише додавати картинки.",
    "Error": "Помилка",
    "Create new topic": "Створити нову тему",
    "Name": "Ім'я",
    "Close": "Закрити",
    "Find topic...": "Знайти тему...",
    "New topic": "Нова тема",
    "Invalid format": "Неприпустимий формат",
    "Demo company account": "Демо-рахунок компанії",
    "Demo account will be deleted later. Do this for testing purposes only!": "Демо-рахунок буде видалено пізніше. Робіть це лише з метою тестування!",
    "Subscribe": "Підписатися",
    "Start demo": "Почати демо",
    "End demo": "Завершити демо",
    "Free trial is expired - {0}": "Термін дії безкоштовної пробної версії закінчився - {0}",
    "Free trial {1} {2} left - {0}": "Залишилось {1} {2} безкоштовної пробної версії - {0}",
    "Add time": "Додайте час",
    "Billable": "Оплачуваних",
    "Date": "Дата",
    "Start": "Початок",
    "End": "Кінець",
    "Duration": "Тривалість",
    "Split duration equally": "Розділіть тривалість порівну",
    "Required field": "Обов'язкове поле",
    "Members list": "Список учасників",
    "Edit fields": "Редагування полів",
    "Maximum number of selected columns has been exceeded": "Перевищено максимальну кількість вибраних стовпців",
    "If you want to add a new column to the report, please remove an existing one first.": "Якщо ви хочете додати новий стовпець до звіту, спершу видаліть наявний.",
    "Snooze until...": "Відкладайте, поки...",
    "Select date & time": "Виберіть дату й час",
    "Tomorrow": "Завтра",
    "Later this week": "Пізніше цього тижня",
    "Next week": "Наступного тижня",
    "Add task": "Додати завдання",
    "Checklist": "Список Перевірки",
    "Start timer": "Таймер запуску",
    "Add an item": "Додавання елемента",
    "Add checklist item": "Додати пункт чек-листа",
    "Convert to a task": "Перетворення на завдання",
    "Delete": "Видалити",
    "Delegate to...": "Делегувати...",
    "Please select tasks from the same account": "Будь ласка, вибирайте завдання з одного облікового запису",
    "Follow": "Стежити",
    "Expand sidebar": "Розгорнути бічну панель",
    "Nicely done!": "Гарно зроблено!",
    "You've finished all your tasks, take a second to recharge": "Ви виконали всі свої завдання, знайдіть секунду, щоб перезарядитися",
    "Search tasks...": "Пошукові завдання...",
    "Search": "Пошук",
    "select/unselect all": "Вибрати/зняти виділення з усіх",
    "Add new client": "Додати нового клієнта",
    "Account": "Обліковий запис",
    "Client name": "Ім'я клієнта",
    "Select client": "Оберіть клієнта",
    "New client": "Новий клієнт",
    "Must be an integer": "Має бути цілим числом",
    "Must be a number": "Має бути число",
    "Dashboard": "Консоль",
    "Calendar": "Календар",
    "Report": "Повідомити",
    "Monitoring": "Моніторинг",
    "Suppliers": "Постачальників",
    "Events": "Події",
    "Projects": "Проекти",
    "Help": "Допомога",
    "Invite a friend": "Invite a friend",
    "Settings & Apps": "Налаштування та додатки",
    "Profile": "Профіль",
    "Collapse menu": "Розгорніть меню",
    "Expand menu": "Розгорнути меню",
    "Are you sure to delete this attachment?": "Ви впевнені, що видалили це вкладення?",
    "Select": "Вибрати",
    "Edit contacts": "Зміна контактів",
    "Add member": "Додати учасника",
    "Add note": "Додати примітку",
    "Open": "Open",
    "Reports": "Звіти",
    "Billing notes": "Примітки щодо виставлення рахунків",
    "Pinned notes": "Закріплені нотатки",
    "Sub-companies": "Дочірні компанії",
    "Contacts": "Контакти",
    "Event info": "Інформація про подію",
    "Project info": "Інформація про проект",
    "Summary": "Резюме",
    "Task": "Задача",
    "Time": "Час",
    "Collapse sidebar": "Згорнути бічну панель",
    "Client Overview": "Огляд клієнта",
    "Event Overview": "Огляд події",
    "Project Overview": "Огляд проекту",
    "Edit client": "Редагувати клієнт",
    "Edit event": "Редагувати подію",
    "Edit project": "Редагувати проект",
    "Show all": "Показати всі",
    "Collapse": "Згорнути",
    "by": "від",
    "View all": "Переглянути все",
    "Copied to clipboard": "Скопійовано в буфер обміну",
    "Client portal invite sent on {0}": "Client portal invite sent on {0}",
    "Client portal invite has not been sent": "Client portal invite has not been sent",
    "Resend invite": "Повторно надіслати запрошення",
    "Send invite": "Надіслати запрошення",
    "Invite sent": "Запрошення надіслано",
    "Add company event": "Додати подію компанії",
    "Company": "Компанія",
    "Info": "Інформація",
    "Holiday": "Свято",
    "All day(s)": "Весь день (дні)",
    "End date": "Дата закінчення",
    "From": "Від",
    "Until": "До",
    "Hours": "Години",
    "Link": "Посилання",
    "Save": "Зберегти",
    "Are you sure that you want to delete this company calendar event?": "Ви впевнені, що хочете видалити цю подію в календарі компанії?",
    "Location of client folder in your document management system": "Location of client folder in your document management system",
    "Defined main folder": "Defined main folder",
    "Custom folder": "Custom folder",
    "Add new role": "Додати нову роль",
    "New role": "Нова роль",
    "Access enabled": "Доступ увімкнено",
    "Waiting for files": "Очікування файлів",
    "Uploaded": "Завантажено",
    "Uploading...": "Триває завантаження ...",
    "Client members": "Клієнти-члени",
    "Email settings": "Налаштування електронної пошти",
    "Or connect new email address": "Або підключіть нову адресу електронної пошти",
    "Connect with Microsoft Exchange or other email server (SMTP)": "Підключення до Microsoft Exchange або іншого сервера електронної пошти (SMTP)",
    "Test email sent": "Надіслано тестовий лист",
    "Email address": "Електронна адреса",
    "Reply address": "Адреса для відповіді",
    "Sender name": "Ім'я відправника",
    "Who can use?": "Хто може використовувати?",
    "Client default address": "Адреса клієнта за замовчуванням",
    "Invalid e-mail": "Недійсна електронна пошта",
    "Role": "Роль",
    "E-mail": "E-mail",
    "Mobile phone": "Мобільний телефон",
    "Work phone": "Робочий телефон",
    "Language": "Мова",
    "Birthday": "Дата народження",
    "Are you sure to delete this contact?": "Ви впевнені, що видалили цей контакт?",
    "Manage contact fields": "Керування полями контактів",
    "Administrative Assistant": "Адміністративний асистент",
    "Board member": "Член правління",
    "CEO": "ГЕН. ДИРЕКТОР",
    "Add contact": "Додати контакт",
    "Contact person": "Контактна особа",
    "Leave page?": "Залишити сторінку?",
    "Changes that you made may not be saved": "Внесені зміни можуть не зберігатися",
    "Leave": "Залишити",
    "Validate tasks": "Validate tasks",
    "The Contact you are trying to delete is an assignee in {0} tasks. Remove the contact from tasks to continue.": "The Contact you are trying to delete is an assignee in {0} tasks. Remove the contact from tasks to continue.",
    "Continue": "Продовжити",
    "Super! We're importing your clients...": "Супер! Ми імпортуємо ваших клієнтів...",
    "Feel free to leave this page. We will pop up a notification when the import is prepared. Then you need to confirm the clients you want to add to Uku.": "Не соромтеся залишати цю сторінку. Ми з'являємо сповіщення, коли імпорт буде підготовлено. Потім вам потрібно підтвердити клієнтів, яких ви хочете додати в Uku.",
    "Please wait...": "Будь ласка, зачекайте ...",
    "Setup API keys": "Налаштування ключів API",
    "You have two options": "У вас є два варіанти",
    "how to setup API keys": "як налаштувати ключі API",
    "Custom import": "Імпорт за власним замовленням",
    "To import clients and volume of work from !INTEGRATION, Uku needs !INTEGRATION API key for every client.": "Для імпорту клієнтів та обсягу робіт з ! ІНТЕГРАЦІЯ, Уку потрібна! Ключ API інтеграції для кожного клієнта.",
    "1. <span class=font-weight-medium>Continue</span> - Uku automatically creates API keys for every client": "1. <span class=\"font-weight-medium\">Продовжити</span> - Uku автоматично створює ключі API для кожного клієнта",
    "1. <span class=font-weight-medium>Custom import</span> - Uku connects only with existing UKU API keys. Create API keys manually in !INTEGRATION before import. Read:": "1. <span class=\"font-weight-medium\">Користувацький імпорт</span> - Uku з'єднується лише з існуючими ключами API UKU. Створюйте ключі API вручну в ! ІНТЕГРАЦІЯ перед імпортом. Читати:",
    "(it takes a lot of time)": "(це займає багато часу)",
    "Import Clients": "Імпорт клієнтів",
    "Country": "Країна",
    "Please choose your country": "Будь ласка, оберіть свою країну",
    "Password": "Пароль",
    "Start import": "Почати імпорт",
    "Insert !INTEGRATION login details (it’s secure) to give one time access to import clients and API keys. Please note that you will get logged out from !INTEGRATION in other browsers.": "Вставити! ІНТЕГРАЦІЯ: дані для входу (це безпечно), щоб надати одноразовий доступ до імпорту клієнтів та ключів API. Будь ласка, зверніть увагу, що ви вийдете з системи ! ІНТЕГРАЦІЯ в інших браузерах.",
    "Update invoice status": "Як оновити статус рахунка-фактури",
    "Update now": "Оновити зараз",
    "Daily @ 14:00": "Щодня @ 14:00",
    "Daily @ 18:00": "Щодня @ 18:00",
    "Updating invoice statuses, please wait...": "Оновлення статусів рахунків-фактур, будь ласка, зачекайте...",
    "Your import is ready": "Імпорт готовий",
    "In the final step you need to confirm the clients you want to add to uku": "На останньому кроці вам потрібно підтвердити клієнтів, яких ви хочете додати до uku",
    "Let's go": "Пішли",
    "Import again": "Імпорт знову",
    "Do you have new clients to import?": "У вас з'явилися нові клієнти для імпорту?",
    "Yes, i do": "Так",
    "View last import": "Переглянути останній імпорт",
    "Email server": "Сервер електронної пошти",
    "Email provider": "Постачальник послуг електронної пошти",
    "Host": "Хост",
    "Port": "Порт",
    "Security": "Безпека",
    "Sender email": "Електронна пошта відправника",
    "Username": "Ім'я користувача",
    "Test connection": "Перевірити підключення",
    "How to set up": "Як налаштувати",
    "Only administrators can activate the app": "Активувати програму можуть лише адміністратори",
    "You are in the waiting list": "Ви перебуваєте в листі очікування",
    "We onboard all applicants one by one": "Ми приймаємо всіх кандидатів по черзі",
    "Connected": "Підключено",
    "Activated": "Активовано",
    "Join waiting list": "Приєднуйтесь до листа очікування",
    "Activate": "Активувати",
    "Unsubscribe from waiting list": "Відписатися від листа очікування",
    "Deactivate app": "Деактивувати додаток",
    "Disconnect": "Відключити",
    "Hide expanded content": "Hide expanded content",
    "Show trimmed content": "Show trimmed content",
    "Email not delivered": "Електронний лист не доставлено",
    "Sent, but fallback to Uku email": "Надіслано, але резервно для електронної пошти Uku",
    "Unknown error": "Невідома помилка",
    "to": "до",
    "automatically": "automatically",
    "in any minute": "за будь-яку хвилину",
    "on {0},": "на {0},",
    "or": "або",
    "Send now": "Надіслати зараз",
    "Uku will no longer send email": "Uku will no longer send email",
    "Uku <span class='subtitle-2'>is sending</span> email": "Uku <span class='subtitle-2'>надсилає</span> електронну пошту",
    "__From_email": "__From_email",
    "Set up email": "Налаштування електронної пошти",
    "Client default": "Клієнт за замовчуванням",
    "Subject": "Тема",
    "Edit email": "Редагувати електронний лист",
    "Template": "Шаблон",
    "Cc": "Копія",
    "Bcc": "Прихована копія",
    "__To_email": "__To_email",
    "__Cc_email": "__Cc_email",
    "__Bcc_email": "__Bcc_email",
    "Add template": "Додати шаблон",
    "Add automation": "Додайте автоматизацію",
    "Add placeholder": "Додати заповнювач",
    "Format text": "Форматування тексту",
    "Add attachment": "Додати файл",
    "Send": "Відправити",
    "Save automation": "Збережіть автоматизацію",
    "Choose email template": "Оберіть шаблон листа",
    "All languages": "Всі мови",
    "No templates found.": "Шаблонів не знайдено.",
    "Edit email template": "Редагувати шаблон листа",
    "Are you sure you want to delete this template? Some tasks will be affected": "Ви впевнені, що хочете видалити цей шаблон? Це вплине на деякі завдання",
    "Are you sure you want to delete this template?": "Ви впевнені, що хочете видалити цей шаблон?",
    "Are you sure you want to save this template, the following tasks will be affected?": "Ви впевнені, що хочете зберегти цей шаблон, це вплине на наступні завдання?",
    "Template name": "Назва шаблону",
    "Edit template": "Редагувати шаблон",
    "Send email": "Відправити",
    "on": "на",
    "Ok": "Ok",
    "Supplier": "Постачальник",
    "Event": "Подія",
    "Contact": "Контакти",
    "Validation failed": "Перевірку не вдалося",
    "Saving supplier failed": "Врятувати постачальника не вдалося",
    "Saving client failed": "Врятувати клієнта не вдалося",
    "Saving project failed": "Врятувати проект не вдалося",
    "several values": "кілька значень",
    "values": "значення",
    "is": "дорівнює",
    "Add filter": "Додати фільтр",
    "Update": "Оновити",
    "forever": "постійно",
    "Last week": "Минулого тижня",
    "This week": "Тиждень",
    "Last month": "Минулого місяця",
    "This month": "Цього місяця",
    "Next month": "Наст. місяць",
    "Last year": "Минулого року",
    "This year": "Цього року",
    "This quarter": "У цьому кварталі",
    "Next quarter": "Наступний квартал",
    "Last quarter": "Останній квартал",
    "Client group": "Група клієнтів",
    "Topic": "Тема",
    "Member": "Учасник",
    "Primary member": "Член Початкового товариства",
    "Client status": "Статус клієнта",
    "Active clients": "Активні клієнти",
    "Inactive clients": "Неактивні клієнти",
    "All": "Всі",
    "Project status": "Статус проекту",
    "Member status": "Статус учасника",
    "Active members": "Активні учасники",
    "Limited members": "Обмежена кількість учасників",
    "Inactive members": "Неактивні учасники",
    "Contract status": "Статус контракту",
    "Active contracts": "Активні контракти",
    "Pending contracts": "Контракти, що очікують на розгляд",
    "Finished contracts": "Готові договори",
    "Contract template": "Шаблон договору",
    "Payment recurrence": "Рекурентність платежів",
    "Yearly": "Щорічно",
    "Monthly": "Щомісяця",
    "Trial": "Пробна версія",
    "Region": "Область",
    "Field": "Поле",
    "All tasks": "Всі завдання",
    "Todo": "Завдання",
    "Not done": "Не виконано",
    "Done": "Готово",
    "Delayed": "Відкладено",
    "Important": "Важливо",
    "Extra work": "Додаткова робота",
    "I Follow": "Я йду за",
    "Commented": "Прокоментував",
    "Tracked time": "Відстежуваний час",
    "Estimated": "За оцінками",
    "Recurring task": "Повторюване завдання",
    "Last import": "Останній імпорт",
    "Period": "Період",
    "Client search": "Пошук клієнта",
    "Voucher": "Ваучер",
    "Company status": "Статус компанії",
    "Deleted": "Видалено",
    "All status": "Весь статус",
    "Payment gateway": "Платіжний шлюз",
    "All gateways": "Всі шлюзи",
    "Uku manually": "Уку вручну",
    "Braintree": "Брейнтрі",
    "Plan status": "Статус плану",
    "All plans": "Всі тарифні плани",
    "Paid": "Оплачений",
    "Paid churn": "Платний відтік",
    "Trial churn": "Пробний відтік",
    "Plan period": "Період планування",
    "All periods": "Всі періоди",
    "Monthly plan": "Місячний план",
    "Yearly plan": "Річний план",
    "Company search": "Пошук компанії",
    "User search": "Пошук користувачів",
    "Name key search": "Пошук за іменним ключем",
    "None filter": "Немає фільтра",
    "OK": "ДОБРЕ",
    "Start date cannot be later than due date": "Дата початку не може бути пізнішою за дату завершення",
    "tasks": "Завдання",
    "task(s) had errors": "У завданнях були помилки",
    "tasks selected": "Обрані завдання",
    "Postpone": "Відкласти",
    "Mark done": "Позначити виконано",
    "Hide multiselect": "Сховати мультивиділення",
    "Delete task(s)": "Видалити завдання",
    "All of the data related to the task will be deleted": "Всі дані, пов'язані із завданням, будуть видалені",
    "Some tasks include other people. Are you sure you want to delete?": "У деяких завданнях беруть участь інші люди. Ви впевнені, що хочете видалити?",
    "Time has been tracked to some of the selected activities. Are you sure you want to delete?": "Було відстежено час для деяких вибраних видів діяльності. Ви впевнені, що хочете видалити?",
    "Time has been tracked to some of the selected activities. Some tasks include other people. Are you sure you want to delete?": "Було відстежено час для деяких вибраних видів діяльності. У деяких завданнях беруть участь інші люди. Ви впевнені, що хочете видалити?",
    "task(s) were not marked done": "Завдання (завдання) не були позначені виконаними",
    "Please check if the checklist has been completed or time is entered and they are assigned to you": "Будь ласка, перевірте, чи виконано чек-лист, чи введено час і вони призначені вам",
    "task(s) were not deleted": "Завдання (завдання) не були видалені",
    "task(s) time was not updated": "Час виконання завдань не оновлено",
    "Please make sure that you can add time to task": "Будь ласка, переконайтеся, що ви можете додати час до завдання",
    "invoice table row": "Рядок таблиці рахунків-фактур",
    "invoice table row(s) had errors": "У рядках таблиці рахунків-фактур були помилки",
    "invoice table row(s) selected": "Вибрані рядки таблиці рахунків-фактур",
    "Create": "Створити",
    "Mark paid": "Позначити сплачено",
    "Send to client": "Відправити клієнту",
    "Recalculate": "Перерахувати",
    "Export to {0}": "Експорт в {0}",
    "Update Status from {0}": "Оновити статус з {0}",
    "Void invoice": "Недійсний рахунок-фактура",
    "Delete invoice": "Видалити рахунок",
    "Restore invoice": "Відновити рахунок-фактуру",
    "Mark unpaid": "Позначити неоплачено",
    "Invoices": "Рахунки-фактури",
    "Download to Excel": "Завантажити в Excel",
    "Revenue split": "Розподіл доходів",
    "Tax": "Податок",
    "Description": "Опис",
    "Percent": "Проценти",
    "Integration Id": "Ідентифікатор інтеграції",
    "Integration Code": "Інтеграційний код",
    "Name on invoice": "Ім'я в рахунку-фактурі",
    "Restore": "Відновлення",
    "Archive": "Архів",
    "Hide": "Сховати",
    "Are you sure?": "Ви впевнені?",
    "Invoice seller": "Invoice seller",
    "Company name": "Назва компанії",
    "Address": "Адреса",
    "Company number": "Код ЄДРПОУ",
    "Tax number": "Tax number",
    "Bank": "Bank",
    "IBAN": "ЄДРПОУ",
    "Delete logo": "Видалити логотип",
    "Upload logo file": "Завантажити файл логотипу",
    "Max. dimensions 130 x 130 px": "Max. dimensions 130 x 130 px",
    "Import finished!": "Імпорт завершено!",
    "Failed to import {0} records": "Не вдалося імпортувати {0} записи",
    "Download report": "Завантажити звіт",
    "Result: added {0}, updated {1}, skipped {2}, failed to import {3}": "Результат: додано {0}, оновлено {1}, пропущено {2}, не вдалося імпортувати {3}",
    "Result: added {0}, updated {1}, skipped {2}": "Результат: додано {0}, оновлено {1}, пропущено {2}",
    "What’s next?": "Що далі?",
    "To work effectively with your client base, complete the following steps:": "Для ефективної роботи з клієнтською базою виконайте наступні кроки:",
    "Read more ›": "Читати повністю ›",
    "Next you will only see active imported clients. To see all clients, remove “Last import” filter.": "Далі ви побачите лише активних імпортованих клієнтів. Щоб побачити всіх клієнтів, зніміть фільтр \"Останній імпорт\".",
    "View clients": "Перегляд клієнтів",
    "Add <b>primary member</b> to every client.": "Додайте <b>основного члена</b> до кожного клієнта.",
    "Add <b>task plan</b> to automate recurring tasks.": "Додайте <b>план завдань</b> , щоб автоматизувати повторювані завдання.",
    "Setup automatic monthly summary under {0} app in Uku to import volume of work.": "Налаштуйте автоматичний щомісячний підсумок у додатку {0} Uku для імпорту обсягу роботи.",
    "Title": "Назва",
    "Field type": "Тип поля",
    "Field name": "Назва поля",
    "Client section": "Client section",
    "Choices": "Варіанти",
    "Type each choice on a separate line": "Введіть кожен варіант в окремому рядку",
    "Required": "Необхідний",
    "For all topics": "Для всіх тем",
    "For specific topics": "Для конкретних тем",
    "Topics": "Теми",
    "Non-billable": "Не підлягає оплаті",
    "Edit task custom field": "Редагування настроюваного поля завдання",
    "Add task custom field": "Додати кастомне поле завдання",
    "Edit client custom field": "Редагування користувацького поля клієнта",
    "Add client custom field": "Додати кастомне поле клієнта",
    "Choice {0}": "Вибір {0}",
    "Are you sure that you want to delete this custom field?": "Ви впевнені, що хочете видалити це кастомне поле?",
    "Warning!": "Увага!",
    "This custom field is in use. Do you wish to archive it?": "Це спеціальне поле використовується. Бажаєте заархівувати його?",
    "Reconnect": "Перепідключитися",
    "Send test email": "Надіслати тестового електронного листа",
    "Email address or username": "Адреса електронної пошти або ім'я користувача",
    "Other": "Інше",
    "Set default email server for company": "Встановіть поштовий сервер за замовчуванням для компанії",
    "My default email": "Моя електронна адреса за умовчанням",
    "Depends on": "Залежить від",
    "Todo - Blocking": "Завдання - Блокування",
    "In progress - Blocking": "В процесі - Блокування",
    "In progress": "У процесі",
    "Client code": "Код клієнта",
    "Primary user": "Основний користувач",
    "Added date": "Додана дата",
    "Updated": "Оновлено",
    "Contract count": "Кількість контрактів",
    "Integration": "Інструкції",
    "No data available": "Немає доступних даних",
    "No results found": "Нічого не знайдено",
    "Loading": "Завантаження",
    "Sort by": "Сортувати за",
    "{0}-{1} of {2}": "{0}-{1} {2}",
    "Rows per page": "Рядки на сторінці",
    "Ongoing": "Тривають",
    "important": "важливий",
    "Read more": "Читати далі",
    "Add to previous time entry": "Додати до попереднього запису часу",
    "Add to next time entry": "Додати до наступного запису",
    "Add new task": "Додати нове завдання",
    "Cut previous time entry": "Вирізати попередній запис часу",
    "Cut next time entry": "Вирізати наступний запис",
    "Missing time entry": "Пропущений час введення",
    "Overlapping time entries": "Перекриття часових записів",
    "Member from custom fields": "Учасник із кастомних полів",
    "Delegated to": "Делеговано",
    "Delegated by": "Делеговано",
    "Visible members": "Видимі учасники",
    "Member type": "Тип членства",
    "Groups": "Групи",
    "Custom field": "Спеціальне поле",
    "Contact search": "Пошук контактів",
    "Task start": "Початок завдання",
    "Task due": "Виконання завдання",
    "Task finish": "Завершення завдання",
    "Custom date": "Нестандартна дата",
    "Never": "Ніколи",
    "Referral status": "Referral status",
    "Invited": "Запрошено",
    "Registered": "Registered",
    "Earned": "Earned",
    "Agreed work is still expected": "Узгоджена робота все ще очікується",
    "Accepted flextime": "Прийнятий гнучкий графік роботи",
    "Declined flextime": "Відмова від гнучкого графіка",
    "Cancelled flextime": "Скасований гнучкий графік роботи",
    "Updated flextime": "Оновлений гнучкий графік роботи",
    "Calendar deleted": "Календар видалено",
    "Calendar created": "Календар створено",
    "Calendar approved": "Затверджено календар",
    "Calendar declined": "Календар відхилено",
    "Calendar updated": "Календар оновлено",
    "Flextime balance updated": "Оновлено баланс гнучкого часу",
    "Flextime": "Гнучкий графік роботи",
    "Vacation": "Відпустка",
    "Balance": "Баланс",
    "Comment": "Коментар",
    "History": "Історія",
    "Action": "Дія",
    "Who": "Хто",
    "Take a vacation or mark an absence": "Візьміть відпустку або відзначте відсутність",
    "Away": "Осторонь",
    "Flextime bonus": "Бонус за гнучкий графік роботи",
    "Approver": "Затверджувач",
    "Vacation available": "Доступна відпустка",
    "Type": "Тип",
    "Reduce agreed working hours": "Скоротіть узгоджений робочий час",
    "Reject": "Відхилити",
    "Approve": "Затвердити",
    "away_type_Away": "away_type_Away",
    "Sick leave": "Лікарняний лист",
    "Parental leave": "Відпустка по догляду за дитиною",
    "Working hours": "Working hours",
    "Mon-Fri, 40h weekly, 8h daily": "Mon-Fri, 40h weekly, 8h daily",
    "Customize": "Customize",
    "Total": "Всього",
    "Settings": "Налаштування",
    "Work on holidays": "Робота у святкові дні",
    "Get {0} in cash for every referral who becomes a Uku client.": "Get {0} in cash for every referral who becomes a Uku client.",
    "Copy your invite link": "Copy your invite link",
    "Hide message": "Hide message",
    "View message": "View message",
    "Your statistics": "Your statistics",
    "Copy message": "Copy message",
    "How it works": "How it works",
    "Invite your friends to Uku, and we'll give a free month of Uku - and show them how to boost their business.": "Invite your friends to Uku, and we'll give a free month of Uku - and show them how to boost their business.",
    "After your referral becomes a paying Uku client, we send you a {0} gift card.": "After your referral becomes a paying Uku client, we send you a {0} gift card.",
    "More ways to earn cash": "More ways to earn cash",
    "referral_email_content": "referral_email_content",
    "Write feedback for Uku and get <a href='/api/help_link/referral_feedback' target='_blank'>{0} gift card here</a>": "Write feedback for Uku and get <a href='/api/help_link/referral_feedback' target='_blank'>{0} gift card here</a>",
    "Expand": "Розгорнути",
    "Wait until event status": "Дочекайтеся статусу події",
    "Wait until project status": "Дочекайтеся статусу проекту",
    "Week(s)": "Тиждень",
    "Day(s)": "День(дні)",
    "Rule": "Правило",
    "Depends on event": "Залежить від події",
    "Depends on project": "Залежить від проекту",
    "Due date in": "Термін виконання в",
    "Status": "Статус",
    "Select event": "Оберіть подію",
    "Select project": "Оберіть проект",
    "Find event...": "Знайти подію...",
    "Find project...": "Знайти проект...",
    "Custom recurrence": "Нетипове повторення",
    "Every": "Кожен",
    "In case of holiday": "У разі відпустки",
    "Set time": "Встановити час",
    "Start time": "Час початку",
    "Repeat from": "Повторити від",
    "Previous repeat from: {0}": "Попередній повтор від: {0}",
    "On date": "За датою",
    "Plus days": "Плюс днів",
    "Due date time": "Термін виконання",
    "Remove recurrence": "Видалення рецидиву",
    "Repeat": "Повторити",
    "month": "місяць",
    "quarter": "чверть",
    "year": "рік",
    "1st month": "1-й місяць",
    "2nd month": "2-й місяць",
    "3rd month": "3-й місяць",
    "Day {0}": "День {0}",
    "Show before": "Показати раніше",
    "Keep the day": "Дотримуйтесь дня",
    "Show after": "Показати після",
    "From start date": "З дати початку",
    "From beginning of the month": "З початку місяця",
    "All days (Mon to Sun)": "Всі дні (з понеділка по нд)",
    "Mon to Fri (incl. holidays)": "Пн-Пт (включаючи святкові дні)",
    "Mon to Fri (excl. holidays)": "Пн-Пт (крім святкових днів)",
    "1st": "1ий",
    "2nd": "2-вох",
    "3rd": "третє",
    "Does not repeat": "Не повторюється",
    "Daily": "Щодня",
    "Weekly on {0}": "Щотижня на {0}",
    "Monthly on day {0}": "Місячні в день {0}",
    "Quarterly on {0} month {1} day": "Щоквартально {0} місяць {1} день",
    "Yearly on {0} {1}": "Щорічно на {0} {1}",
    "Custom...": "Користувацькі...",
    "Incorrect time": "Неправильний час",
    "Add repeat": "Додати повтор",
    "Email added to queue": "Електронна пошта додана в чергу",
    "Communication timeline": "Хронологія зв'язку",
    "Activate Email App in App Store to send automated emails and view your past and future communication in one place.": "Активуйте програму електронної пошти в App Store, щоб надсилати автоматичні електронні листи та переглядати своє минуле та майбутнє спілкування в одному місці.",
    "Go to App Store": "Перейдіть в App Store",
    "Unknown": "Невідомо",
    "<b>Email</b> from": "<b>Електронна пошта</b> від",
    "To": "До",
    "Planned": "Заплановані",
    "Automated emails scheduled to be sent in the future": "Автоматичні електронні листи, які планується надсилати в майбутньому",
    "Send e-mail": "Відправити e-mail",
    "Template unlinked": "Шаблон без зв'язку",
    "Icon": "Іконка",
    "Link name": "Link name",
    "Link URL": "Link URL",
    "Open in new tab": "Open in new tab",
    "Visible": "Видиме",
    "External": "External",
    "Not external": "Not external",
    "Company default": "Дефолт компанії",
    "Not visible": "Not visible",
    "Use company default": "Use company default",
    "or choose icon": "or choose icon",
    "Find member...": "Знайти учасника...",
    "I'll take it": "Я візьму",
    "Remove me": "Вилучити мене",
    "Remove from task": "Видалити із завдання",
    "Learn more": "Дізнатися більше",
    "Company settings edit is disabled by owner": "Редагування налаштувань компанії вимкнено власником",
    "<b>Exported</b> {0} to {1}": "<b>Експортовані</b> {0} до {1}",
    "<b>Sent to client</b> {0} from {1}": "<b>Sent to client</b> {0} from {1}",
    "<b>Paid {0}</b> {1}": "<b>Платні {0}</b> {1}",
    "<b>Annulled</b> {0}": "<b>Анульовано</b> {0}",
    "Do you wish to mark the task done for everyone?": "Бажаєте відзначити виконане завдання для всіх?",
    "No, remove me": "Ні, видаліть мене",
    "Task won’t be marked done, but user is removed from the assignees and added to the followers of the task": "Завдання не буде позначено як виконане, але користувача буде вилучено з числа призначених осіб і додано до підписників завдання",
    "Invalid email": "Недійсна електронна пошта",
    "Accounting": "Бухгалтерський облік",
    "General": "Загальні",
    "Advertising / Marketing/ PR": "Реклама / Маркетинг / PR",
    "Architecture": "Архітектура",
    "Construction": "Будівництво",
    "Consulting - IT, software": "Консалтинг - IT, програмне забезпечення",
    "Consulting - Management": "Консалтинг - Менеджмент",
    "Finance": "Фінанси",
    "Legal": "Юридична інформація",
    "Medicine / Pharmacy ": "Медицина / Фармація ",
    "Non-profit": "Некомерційна організація",
    "Web design": "Веб-дизайн",
    "Web development": "Веб-розробка",
    "Max 140 characters": "Максимум 140 символів",
    "Please complete the checklist": "Будь ласка, заповніть чек-лист",
    "It is required to mark all checklist items as done": "Потрібно відзначити всі пункти чек-листа як виконані",
    "Please enter time spent": "Будь ласка, введіть витрачений час",
    "Inserting time is essential for this client": "Час вставки має важливе значення для цього клієнта",
    "Only me": "Тільки я",
    "Private": "Приватний",
    "Edit note": "Редагувати примітку",
    "Add additional information about the client, such as special agreements, passwords, etc.": "Додайте додаткову інформацію про клієнта, наприклад, спеціальні угоди, паролі тощо.",
    "Edit": "Редагувати",
    "Workdays": "Трудові будні",
    "Workhours": "Робочий час",
    "Weeks": "Тижні",
    "Clear filters": "Очистити фільтри",
    "Save filters": "Зберегти фільтри",
    "Expected": "Очікуваний",
    "Estimation": "Оцінки",
    "Do you also want to postpone the due date?": "Ви теж хочете перенести дату пологів?",
    "{0} week": "{0} тиждень",
    "{0} weeks": "{0} тижнів",
    "Vacations": "Канікули",
    "Holidays": "Свята",
    "Tax dates": "Податкові дати",
    "Accounting news": "Новини бухгалтерського обліку",
    "Company events": "Події компанії",
    "Member birthdays": "Дні народження учасників",
    "Contact birthdays": "Зв'язатися з днями народження",
    "Group items": "Групування елементів",
    "Don't group": "Не групувати",
    "{0} away": "{0} геть",
    "Member birthday | Member birthdays": "День народження учасника | Дні народження учасників",
    "Contact birthday | Contact birthdays": "Зв'язатися з днем народження | Зв'язатися з днями народження",
    "Contact birthday": "Зв'язатися з днем народження",
    "Member birthday": "День народження учасника",
    "Are you sure you wish to delete this link?": "Ви впевнені, що хочете видалити це посилання?",
    "Reference name": "Назва посилання",
    "Reference link": "Посилання на джерело",
    "Free trial": "Безкоштовна пробна версія",
    "Solo": "Соло",
    "Team": "Команда",
    "Enterprise": "Підприємство",
    "Mini Uku": "Міні Уку",
    "Chrome browser plugin for Uku to manage your task, clients and track time.": "Плагін браузера Chrome для Uku для керування завданнями, клієнтами та відстеження часу.",
    "Setup task/job plans to automate your workflow, add topics, custom fields and modify your preferences.": "Налаштуйте плани завдань/робіт, щоб автоматизувати свій робочий процес, додайте теми, настроювані поля та змініть свої налаштування.",
    "Setup client groups, custom fields and modify your preferences.": "Налаштуйте групи клієнтів, кастомні поля та змініть свої налаштування.",
    "test": "тест",
    "Anti Money Laundering": "Боротьба з відмиванням грошей",
    "Setup your customer AML and get instant reminders when auditing is due.": "Налаштуйте AML своїх клієнтів і отримуйте миттєві нагадування, коли настане час аудиту.",
    "flextime_description": "flextime_description",
    "Smart Accounts": "Розумні облікові записи",
    "Automatically imports work statistics from your accounting software.": "Автоматично імпортує статистику роботи з вашого бухгалтерського програмного забезпечення.",
    "Merit Aktiva": "Заслуга Активи",
    "360 Księgowość": "360 Księgowość",
    "Speed up your client billing process with pricelists and smart contracts.": "Прискорте процес виставлення рахунків клієнтам за допомогою прайс-листів і смарт-контрактів.",
    "Visual report will tell you exactly how profitable or unprofitable your client is.": "Візуальний звіт точно покаже, наскільки прибутковий або збитковий ваш клієнт.",
    "Emailing description": "Опис листа",
    "e-conomic": "e-conomic",
    "Sync client data from Uku to e-conomic and vice versa. View sales ledger information for each client.": "Синхронізуйте дані клієнта з Uku на e-conomic і навпаки. Переглядайте інформацію в книзі продажів по кожному клієнту.",
    "Xero": "Xero",
    "xero_description": "xero_description",
    "QuickBooks": "Швидкі книги",
    "quickbooks_description": "quickbooks_description",
    "Tripletex": "Триплетекс",
    "tripletex_description": "tripletex_description",
    "Scoro": "Скоро",
    "Export sales invoices.": "Експорт видаткових накладних.",
    "Fortnox": "Фортнокс",
    "fortnox_description": "fortnox_description",
    "Magic button": "Чарівна кнопка",
    "With one click - a quick and easy way to create important tasks. For example, a phone call from a client.": "Одним кліком - швидкий і простий спосіб створення важливих завдань. Наприклад, телефонний дзвінок від клієнта.",
    "With suppliers, you make your projects and partners management more efficient.": "З постачальниками ви робите управління своїми проектами та партнерами більш ефективним.",
    "Powerful and flexible project management serves diverse use cases and workflows.": "Потужне та гнучке управління проектами обслуговує різноманітні сценарії використання та робочі процеси.",
    "client_portal_app_description": "client_portal_app_description",
    "Chat": "Чат",
    "chat_app_description": "chat_app_description",
    "Companies House": "Будинки компаній",
    "companies_house_app_description": "companies_house_app_description",
    "documents_app_description": "documents_app_description",
    "FreeAgent": "FreeAgent",
    "freeagent_description": "freeagent_description",
    "Trigon": "Trigon",
    "trigon_description": "trigon_description",
    "Connect and discover tools to help you manage your business.": "Підключіться та відкрийте для себе інструменти, які допоможуть вам керувати своїм бізнесом.",
    "Subscribe now": "Підписатися зараз",
    "Compare plans": "Порівняти тарифні плани",
    "Add company": "Додати компанію",
    "BETA": "БЕТА",
    "Setup": "Налаштування",
    "Power up": "Увімкніть живлення",
    "Integrations": "Інтеграції",
    "Hi! Do you want to work with a team and use extra features? No problem, first add your company!": "Привіт! Хочеш працювати з командою та використовувати додаткові функції? Не біда, спочатку додайте свою компанію!",
    "Read more about Uku plans": "Дізнайтеся більше про плани Uku",
    "Contact role": "Роль контактної особи",
    "Contact roles": "Ролі контактних осіб",
    "Client groups": "Групи клієнтів",
    "Client fields": "Поля клієнта",
    "Contact fields": "Поля контактів",
    "View archive": "Переглянути архів",
    "Restore from archive": "Відновити з архіву",
    "Empty list": "Порожній список",
    "Task fields": "Поля завдань",
    "task topics": "Теми завдань",
    "Keep the task opened when starting the timer": "Тримайте завдання відкритим під час запуску таймера",
    "task templates": "Шаблони завдань",
    "Author": "Автор",
    "Duplicate": "Дублювати",
    "Uku task templates": "Шаблони завдань Uku",
    "Are you sure that you want to delete this task template?": "Ви впевнені, що хочете видалити цей шаблон завдання?",
    "Templates": "Шаблон",
    "Overview": "Огляд",
    "chat_app_overview_text": "chat_app_overview_text",
    "Color": "Колір",
    "Are you sure to delete this field? You may lose the data.": "Ви впевнені, що видалили це поле? Ви можете втратити дані.",
    "Add field": "Додати поле",
    "Add section": "Додати секцію",
    "multiline": "Багаторядковий",
    "Import": "Імпорт",
    "Import data": "Імпорт даних",
    "Automate data collection with Smart Accounts": "Автоматизуйте збір даних за допомогою смарт-акаунтів",
    "<ul><li>Import purchase and sales entries, total entries and entry lines count;</li><li>Automate data collection with Smart Accounts;</li><li>Faster & more accurate billing through automated data exchange. Uku gathers information for preparing customers' invoices in one place and makes invoicing efficient.</li></ul>": "<ul><li>Підрахунок записів про купівлю та продаж імпорту, загальної кількості проводок та рядків входу;</li><li>Автоматизуйте збір даних за допомогою Smart Accounts;</li><li>Швидший і точніший виставлення рахунків завдяки автоматизованому обміну даними. Uku збирає інформацію для підготовки рахунків-фактур клієнтів в одному місці та робить виставлення рахунків ефективним.</li></ul>",
    "xero_app_overview_text": "xero_app_overview_text",
    "Import clients from {0}": "Імпорт клієнтів з {0}",
    "Before importing clients, you need to authorize with Xero and select the Company.": "Перш ніж імпортувати клієнтів, вам потрібно авторизуватися в Xero та вибрати компанію.",
    "Authorize Xero to start import": "Авторизація Xero для запуску імпорту",
    "Failed to import clients": "Не вдалося імпортувати клієнтів",
    "Failed to connect to WS": "Не вдалося підключитися до WS",
    "emailing_app_overview_text": "emailing_app_overview_text",
    "Email signatures": "Email signatures",
    "Everyone": "Всі",
    "Access": "Доступ",
    "Creator": "Автор",
    "Are you sure you want to delete this signature? Some emails will be affected": "Are you sure you want to delete this signature? Some emails will be affected",
    "Email addresses": "Адреси електронної пошти",
    "Signatures": "Signatures",
    "Send emails": "Send emails",
    "Uku securely integrates with your email to help you manage and automate communication": "Uku безпечно інтегрується з вашою електронною поштою, щоб допомогти вам керувати та автоматизувати спілкування",
    "Use {0} address": "Використовуйте {0} адресу",
    "connect your email address": "Підключіть свою адресу електронної пошти",
    "Connect with Microsoft Exchange or other email server(SMTP)": "Підключення до Microsoft Exchange або іншого сервера електронної пошти (SMTP)",
    "Email integration reconnected": "Повторне підключення інтеграції з електронною поштою",
    "Are you sure you want to delete this email integration?": "Ви впевнені, що хочете видалити цю інтеграцію з електронною поштою?",
    "Email templates": "Шаблони електронної пошти",
    "Add email template": "Додати шаблон листа",
    "Are you sure you want to save this template? Some tasks will be affected": "Ви впевнені, що хочете зберегти цей шаблон? Це вплине на деякі завдання",
    "Clients can leave task messages by replying to client portal email": "Clients can leave task messages by replying to client portal email",
    "Send a copy of client's response to member's inbox": "Send a copy of client's response to member's inbox",
    "Email recipients can leave task comments by replying to a task email": "Email recipients can leave task comments by replying to a task email",
    "economic_app_overview_text": "economic_app_overview_text",
    "Default layout": "Макет за замовчуванням",
    "Change agreement ID": "Як змінити ідентифікатор угоди",
    "Failed to connect to server": "Не вдалося підключитися до сервера",
    "Uku will import all clients, clients info and classificatiors. In the final step you can select which clients you want to add or update.": "Uku імпортує всіх клієнтів, інформацію про клієнтів та класифікатори. На останньому кроці ви можете вибрати, яких клієнтів ви хочете додати або оновити.",
    "Connect e-conomic": "Підключіть e-conomic",
    "Before importing clients, you need to connect Uku and economic software. To do this, create economic agreement and enter the agreement ID here.": "Перед імпортом клієнтів потрібно підключити Uku та економічне програмне забезпечення. Для цього створіть господарський договір і введіть тут ідентифікатор угоди.",
    "Step {0}": "Крок {0}",
    "Get agreement ID": "Отримати ідентифікатор угоди",
    "Insert agreement ID": "Вставте ідентифікатор угоди",
    "Connect": "Підключити",
    "quickbooks_app_overview_text": "quickbooks_app_overview_text",
    "Uku will import all clients, clients info and classificatiors from QuickBooks. In the final step you can select which clients you want to add or update.": "Uku імпортує всіх клієнтів, інформацію про клієнтів та класифікатори з QuickBooks. На останньому кроці ви можете вибрати, яких клієнтів ви хочете додати або оновити.",
    "Before importing clients, you need to connect with QuickBooks.": "Перш ніж імпортувати клієнтів, вам потрібно підключитися до QuickBooks.",
    "Connected to QuickBooks": "Підключено до QuickBooks",
    "fortnox_app_overview_text": "fortnox_app_overview_text",
    "Uku will import all clients, clients info and classificators from Fortnox. In the final step you can select which clients you want to add or update.": "Uku імпортуватиме всіх клієнтів, інформацію про клієнтів та класифікатори з Fortnox. На останньому кроці ви можете вибрати, яких клієнтів ви хочете додати або оновити.",
    "Before importing clients, you need to connect with Fortnox.": "Перш ніж імпортувати клієнтів, вам потрібно зв'язатися з Fortnox.",
    "Connect to Fortnox": "Підключіться до Fortnox",
    "Connected to Fortnox": "Підключений до Fortnox",
    "Delete template": "Видалити шаблон",
    "Public": "Публічний",
    "Workflow templates": "Шаблони робочих процесів",
    "No workflow templates yet": "Шаблонів робочих процесів ще немає",
    "Modified": "Змінений",
    "Uku workflow templates": "Шаблони робочих процесів Uku",
    "Are you sure you wish to delete this workflow?": "Ви впевнені, що хочете видалити цей робочий процес?",
    "Project fields": "Поля проекту",
    "Progress step": "Крок прогресу",
    "Rename project": "Перейменувати проєкт",
    "Project statuses": "Статуси проектів",
    "You can use the statuses to restrict the workflow.": "Ви можете використовувати статуси, щоб обмежити робочий процес.",
    "Project phases": "Етапи проекту",
    "Make your progress beautiful.": "Зробіть свій прогрес прекрасним.",
    "Permissions": "Дозволи",
    "Users can manage workflow templates": "Користувачі можуть керувати шаблонами робочих процесів",
    "project_app_overview_text": "project_app_overview_text",
    "project_app_overview_description": "project_app_overview_description",
    "Configure summary task": "Настроювання підсумкового завдання",
    "Uku will generate task with following title and topic on the last day of the month.": "В останній день місяця Uku згенерує завдання з наступною назвою та темою.",
    "Task title": "Назва завдання",
    "Recurrence": "Повторення",
    "First import start date": "First import start date",
    "Count changes from previous periods": "Підрахунок змін у порівнянні з попередніми періодами",
    "If enabled, changes made to previous periods will be added to current month. If disabled, changes made to previous periods will not be accounted for.": "Якщо цей параметр увімкнено, зміни, внесені до попередніх періодів, будуть додані до поточного місяця. Якщо вимкнено, зміни, внесені до попередніх періодів, не враховуватимуться.",
    "Automatically finish summary tasks": "Automatically finish summary tasks",
    "If enabled, summary tasks will be created as finished.": "If enabled, summary tasks will be created as finished.",
    "Configure data fields": "Налаштування полів даних",
    "Select corresponding Uku field for each imported field. Same fields will be summarized. By leaving some field blank it will be ignored.": "Виберіть відповідне поле Uku для кожного імпортованого поля. Ці ж поля будуть підсумовуватися. Якщо залишити деяке поле порожнім, воно буде проігноровано.",
    "New custom field": "Нове кастомне поле",
    "Show more": "Показати більше",
    "Every month": "Щомісяця",
    "Last work day of the month": "Last work day of the month",
    "Last day of the month": "Останній день місяця",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "10": "10",
    "11": "11",
    "12": "12",
    "13": "13",
    "14": "14",
    "15": "15",
    "16": "16",
    "17": "17",
    "18": "18",
    "19": "19",
    "20": "20",
    "21": "21",
    "22": "22",
    "23": "23",
    "24": "24",
    "25": "25",
    "26": "26",
    "27": "27",
    "28": "28",
    "Day {0} of next month": "День {0} наступного місяця",
    "Settings saved": "Налаштування збережено",
    "Uku will let you know when it is ready.": "Uku повідомить вам, коли він буде готовий.",
    "Reload data": "Перезавантаження даних",
    "months": "місяці",
    "This will overwrite existing summary tasks new values.": "Це перезапише існуючі сумарні завдання новими значеннями.",
    "Overwrite": "Перезаписати",
    "trigon_app_overview_text": "trigon_app_overview_text",
    "Uku will import all clients and their info from Trigon. In the final step you can select which clients you want to add or update.": "Uku will import all clients and their info from Trigon. In the final step you can select which clients you want to add or update.",
    "Connect Trigon": "Connect Trigon",
    "Before importing clients, you need to connect Uku and Trigon software. To do this, enter your credentials here.": "Before importing clients, you need to connect Uku and Trigon software. To do this, enter your credentials here.",
    "Insert email and password": "Insert email and password",
    "Automate your anti money laundering process": "Автоматизуйте процес боротьби з відмиванням грошей",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Profile valid until</il><li>AML Staus</il><li>Document NO</il><li>Document valid until</li></ul>": "Ви збираєтеся активувати процес боротьби з відмиванням грошей. Під час цього до даних ваших клієнтів будуть додані нові додаткові поля, а також система почне нагадувати вам про їх оновлення.<br><br>Додатковими полями є:<ul><li>Ризик-профіль<li>Профіль дійсний до<li>AML Staus<li>Документ NO<li>Документ дійсний до</li></li></li></li></li></ul>",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Next AML check</il><li>Pass/Fail</il><li>ID type</il><li>ID Number</il><li>Date of expiry</il><li>Additional checks</li></ul>": "Ви збираєтеся активувати процес боротьби з відмиванням грошей. Під час цього до даних ваших клієнтів будуть додані нові додаткові поля, а також система почне нагадувати вам про їх оновлення.<br><br>Додатковими полями є:<ul><li>Ризик-профіль<li>Наступна AML-перевірка<li>Склав/не склав<li>Тип ідентифікатора<li>Ідентифікаційний номер<li>Дата закінчення терміну придатності<li>Додаткові перевірки</li></li></li></li></li></li></li></ul>",
    "Do not change client custom fields created by Uku": "Не змінюйте користувацькі поля клієнта, створені Uku",
    "day(s) before": "день (дні) напередодні",
    "Task name": "Назва завдання",
    "Assigned": "Призначено",
    "Note": "Примітка",
    "Manual run": "Ручний запуск",
    "Create a task when the document expires": "Створення завдання після закінчення терміну дії документа",
    "Create a task when the risk profile must be updated": "Створіть завдання, коли потрібно оновити ризик-профіль",
    "Flextime period": "Гнучкий графік роботи",
    "Confirmation period": "Confirmation period",
    "Weekly": "Щотижня",
    "Add agreement": "Додати згоду",
    "flextime_app_overview_text": "flextime_app_overview_text",
    "supplier_app_overview_text": "supplier_app_overview_text",
    "supplier_app_overview_description": "supplier_app_overview_description",
    "Supplier type": "Тип постачальника",
    "Parent type": "Батьківський тип",
    "Edit supplier type": "Як змінити тип постачальника",
    "New supplier type": "Новий тип постачальника",
    "Are you sure you wish to delete this supplier type?": "Ви впевнені, що хочете видалити цей тип постачальника?",
    "Types": "Типи",
    "Supplier types": "Типи постачальників",
    "No supplier types yet": "Типів постачальників поки що немає",
    "tripletex_app_overview_text": "tripletex_app_overview_text",
    "Uku will import all clients, clients info and classificators from Tripletex. In the final step you can select which clients you want to add or update.": "Uku імпортує всіх клієнтів, інформацію про клієнтів та класифікатори з Tripletex. На останньому кроці ви можете вибрати, яких клієнтів ви хочете додати або оновити.",
    "Connect Tripletex": "Підключіть Триплетекс",
    "Before importing clients, you need to connect Uku and Tripletex software. To do this, create employee token and enter it here.": "Перед імпортом клієнтів необхідно підключити програмне забезпечення Uku та Tripletex. Для цього створіть токен співробітника і введіть його сюди.",
    "Get employee token": "Отримати токен співробітника",
    "Insert employee token": "Вставте токен співробітника",
    "Install": "Встановити",
    "Open Chrome browser to install": "Відкрийте браузер Chrome, щоб встановити",
    "Works with your online accounting software.": "Працює з вашим бухгалтерським онлайн-програмним забезпеченням.",
    "New tasks can strike like lightning and that’s why Mini Uku is your best friend. No matter whether you’re making bank transfers or working in your accounting software; with Mini Uku you can add new tasks, track time and keep on top of all your notifications from any website.<br><br>Just one click on the owl icon provides an overview of your entire working day and helps you plan your schedule more efficiently.": "Нові завдання можуть вражати як блискавка, і саме тому Mini Uku — ваш найкращий друг. Незалежно від того, здійснюєте ви банківські перекази чи працюєте у своєму бухгалтерському програмному забезпеченні; за допомогою Mini Uku ви можете додавати нові завдання, відстежувати час і бути в курсі всіх сповіщень з будь-якого веб-сайту.<br><br>Лише одне натискання на значок сови надає огляд усього вашого робочого дня та допомагає ефективніше планувати свій графік.",
    "merit_aktiva_app_overview_text_pl": "merit_aktiva_app_overview_text_pl",
    "merit_aktiva_app_overview_text": "merit_aktiva_app_overview_text",
    "Import clients": "Імпорт клієнтів",
    "documents_app_overview_text": "documents_app_overview_text",
    "Connect your existing document management system": "Connect your existing document management system",
    "Main folder": "Main folder",
    "Under this folder, Uku automatically creates folders for each client.": "Under this folder, Uku automatically creates folders for each client.",
    "You can customize each client folder separately under client settings.": "You can customize each client folder separately under client settings.",
    "Automatically create Public folder for client files and Private folder for member files": "Automatically create Public folder for client files and Private folder for member files",
    "Automatically create  Year / Month subfolder under each client for files sorting": "Automatically create  Year / Month subfolder under each client for files sorting",
    "Automatically create  Notes and Templates subfolders under each client for files sorting": "Automatically create  Notes and Templates subfolders under each client for files sorting",
    "Add task files added by Members": "Add task files added by Members",
    "Add task files added by Clients (from emails and client portal)": "Add task files added by Clients (from emails and client portal)",
    "Backup files to Uku file storage": "Backup files to Uku file storage",
    "Perfect example": "Perfect example",
    "Setup your SharePoint connection": "Setup your SharePoint connection",
    "Site URL": "Site URL",
    "Client ID": "Client ID",
    "Client secret": "Client secret",
    "Connection successful!": "Підключення успішне!",
    "When disconnecting the service Uku will no longer be able to access the documents.": "When disconnecting the service Uku will no longer be able to access the documents.",
    "Google Drive": "Google Drive",
    "OneDrive": "OneDrive",
    "SharePoint": "SharePoint",
    "Select folder": "Select folder",
    "Manage": "Manage",
    "Refresh": "Оновити",
    "Be aware of the issues before they become problems": "Усвідомлюйте проблеми до того, як вони стануть проблемами",
    "<ul><li>Real time comparison of client contract and actual work done;</li><li>Be aware of the issues before they become problems;</li><li>Even with fixed prices you need to have internal measurements. Monitor the validity of the client’s agreement by comparing it with the actual amount of work done.</li></ul>": "<ul><li>Порівняння клієнтського договору та фактично виконаної роботи в режимі реального часу;</li><li>Усвідомлюйте проблеми до того, як вони стануть проблемами;</li><li>Навіть при фіксованих цінах потрібно мати внутрішні виміри. Слідкуйте за дійсністю угоди клієнта, порівнюючи її з фактичним обсягом виконаних робіт.</li></ul>",
    "client_portal_app_overview_text": "client_portal_app_overview_text",
    "Branding": "Фірмовий стиль",
    "Subdomain": "Субдомен",
    "Default language": "Мова за замовчуванням",
    "Client portal URL in other languages": "URL-адреса клієнтського порталу іншими мовами",
    "Copy URL": "Скопіювати URL-адресу",
    "Trademark": "Торговою маркою",
    "Default signature": "Default signature",
    "Trademark text color": "Колір тексту торгової марки",
    "Choose color": "Натисніть для вибору кольору",
    "Brand background color": "Колір фону бренду",
    "Logo": "Логотип",
    "Max. dimensions 180 x 60 px": "розміри 180 x 60 px",
    "Favicon": "Favicon",
    "Delete icon": "Видалити значок",
    "Upload icon file": "Завантажити файл піктограми",
    "Recommended size 260 x 260 px": "Рекомендований розмір: 260 x 260 px",
    "Company description": "Опис компанії",
    "Displayed on the login page.": "Відображається на сторінці входу.",
    "Describe here what services you offer and how you help your clients.": "Опишіть тут, які послуги ви пропонуєте і як допомагаєте своїм клієнтам.",
    "Welcome video": "Вітальне відео",
    "Displayed on the login page when your client contact enters for the first time": "Відображається на сторінці входу, коли контакт клієнта вводиться вперше",
    "Use Uku video": "Використання відео Uku",
    "View": "Перегляд",
    "Use other video": "Використовуйте інше відео",
    "Youtube or Vimeo video URL": "URL-адреса відео на Youtube або Vimeo",
    "Show file upload box for client tasks": "Показати вікно завантаження файлу для завдань клієнта",
    "Invalid data": "Невірні дані",
    "Client portal preview": "Попередній перегляд клієнтського порталу",
    "Client portal URL for {0} copied to clipboard": "URL-адреса клієнтського порталу для {0} скопійовано в буфер обміну",
    "Personalize your client portal's menu": "Personalize your client portal's menu",
    "Menu links saved": "Menu links saved",
    "Add custom links to essential items such as: Documents, Financial reports, Onboarding forms, Feedback surveys, Service agreements, Pricing, Instructions, Invoices. This section allows you to build the menu structure, set the order of items, and define default links. You can also customize names and links for each client individually. Only menus with defined links are displayed in client portal. <a href='/api/help_link/cp_menu_links' target='_blank'>Read more ›</a>": "Add custom links to essential items such as: Documents, Financial reports, Onboarding forms, Feedback surveys, Service agreements, Pricing, Instructions, Invoices. This section allows you to build the menu structure, set the order of items, and define default links. You can also customize names and links for each client individually. Only menus with defined links are displayed in client portal. <a href='/api/help_link/cp_menu_links' target='_blank'>Read more ›</a>",
    "Menu links": "Menu links",
    "Uku will import all clients from FreeAgent. In the final step you can select which clients you want to add or update.": "Uku will import all clients from FreeAgent. In the final step you can select which clients you want to add or update.",
    "Before importing clients, you need to connect with FreeAgent.": "Before importing clients, you need to connect with FreeAgent.",
    "Connect to FreeAgent": "Connect to FreeAgent",
    "Connected to FreeAgent": "Connected to FreeAgent",
    "freeagent_app_overview_text": "freeagent_app_overview_text",
    "Add recurring task": "Додавання повторюваних завдань",
    "Reminder tasks updated": "Завдання з нагадуваннями оновлені",
    "Create recurring tasks for Companies House clients.": "Створюйте повторювані завдання для клієнтів Companies House.",
    "companies_house_app_overview_text": "companies_house_app_overview_text",
    "buttons": "кнопки",
    "Show to me": "Покажи мені",
    "magic_button_app_overview_text": "magic_button_app_overview_text",
    "Buttons": "Кнопки",
    "Member rights": "Права учасників",
    "Allow managers to view and create their client contracts and invoices": "Дозвольте менеджерам переглядати та створювати свої клієнтські договори та рахунки-фактури",
    "Allow members to view and create their client invoices": "Дозвольте учасникам переглядати та створювати свої рахунки-фактури",
    "Allow members to view their client invoices": "Дозвольте учасникам переглядати рахунки-фактури своїх клієнтів",
    "Allow only owners to add and update products": "Дозволити лише власникам додавати й оновлювати товари",
    "Allow members to send invoices to clients": "Allow members to send invoices to clients",
    "Allow members to confirm their client invoice rows": "Дозвольте учасникам підтверджувати рядки рахунків-фактур клієнтів",
    "Send PDF invoice": "Надіслати рахунок-фактуру у форматі PDF",
    "Send invoice copy": "Send invoice copy",
    "Default rounding": "Округлення за замовчуванням",
    "Round all times up to x": "Округлити всі часи до x",
    "Time rounding increment": "Крок округлення в часі",
    "Apply time rounding to": "Застосуйте округлення до",
    "Default configuration": "Конфігурація за замовчуванням",
    "Invoice date": "Дата виставлення рахунка-фактури",
    "Invoice entry date": "Дата введення рахунку-фактури",
    "Bill tracked time by": "Білл відстежує час за",
    "Bill task field by": "Поле завдання Bill by",
    "Create one invoice merging invoices from the same period": "Створіть один рахунок-фактуру, об'єднавши рахунки-фактури за один період",
    "Invoices from the same period": "Рахунки-фактури за аналогічний період",
    "Hide zero sum lines": "Приховування рядків з нульовою сумою",
    "By default, time entry is billable": "За замовчуванням введення часу є платним",
    "Invoice number": "Номер Рахунка-фактури",
    "Prefix": "Префікс",
    "Suffix": "Суфікс",
    "Google Gmail": "Google Gmail",
    "Microsoft Outlook": "Microsoft Outlook",
    "Billing settings saved": "Збережені налаштування платежів",
    "billing_app_overview_text": "billing_app_overview_text",
    "Products": "Товари",
    "Contract templates": "Шаблони договорів",
    "Invoice templates": "Шаблони рахунків",
    "Tools": "Інструменти",
    "Replace tax": "Замінити податок",
    "Old tax": "Старий податок",
    "New tax": "Новий податок",
    "Find tax": "Знайти податок",
    "Replace VAT in products": "Заміна ПДВ у товарах",
    "Replace VAT in master contracts": "Заміна ПДВ у генеральних договорах",
    "Replace VAT in client contracts & draft invoices": "Заміна ПДВ у клієнтських договорах і проектах рахунків-фактур",
    "Replace VAT values": "Заміна значень ПДВ",
    "This action cannot be undone": "Цю дію не можна скасувати",
    "Replace": "Замінити",
    "Result": "Результат",
    "PDF templates": "PDF-шаблони",
    "E-mail templates": "E-mail шаблони",
    "Edit PDF template": "Редагувати PDF-шаблон",
    "Import classificators": "Класифікатори імпорту",
    "products": "товари",
    "product": "продукт",
    "Product / service": "Товар / послуга",
    "Calculate": "Порахувати",
    "Article": "Стаття",
    "Resource": "Ресурс",
    "Cost center": "Центр витрат",
    "Taxes": "Податки",
    "Code": "Код",
    "Source": "Джерело",
    "Articles": "Статті",
    "Resources": "Ресурси",
    "Cost centers": "Центри витрат",
    "Units": "Одиниця",
    "Unit": "Секція",
    "Bank accounts": "Банківські рахунки",
    "Bank account": "Банківський рахунок",
    "Bank name": "Назва банку",
    "SWIFT code": "SWIFT-код",
    "VAT number": "Номер ПДВ",
    "Do you wish to import only new data or also overwrite existing?": "Ви бажаєте імпортувати лише нові дані або також перезаписати існуючі?",
    "Only new": "Тільки нові",
    "New items will be added. Existing ones will remain unchanged by import.": "Будуть додані нові елементи. Існуючі залишаться незмінними при імпорті.",
    "Import everything": "Імпортувати все",
    "Connect accounting service": "Підключити бухгалтерський сервіс",
    "Service": "Обслуговування",
    "API ID": "Ідентифікатор API",
    "API key": "Ключ API",
    "Company Account Id": "Ідентифікатор облікового запису компанії",
    "Api secret": "Секрет API",
    "E-conomic": "E-conomic",
    "SmartAccounts": "SmartAccounts",
    "Test": "Тест",
    "Lock time entries": "Блокування записів часу",
    "Owner rights": "Права власника",
    "Disable company settings edit for all members": "Вимкніть редагування налаштувань компанії для всіх учасників",
    "Disable personal clients for members": "Відключення персональних клієнтів для учасників",
    "Show member birthdays": "Показувати дні народження учасників",
    "Show contact birthdays": "Показати дні народження контактів",
    "Weekly @ Sun {0}": "Щотижня @ Sun {0}",
    "Monthly @ last day of month": "Щомісяця @ останній день місяця",
    "Company event list": "Список подій компанії",
    "How long?": "Як довго?",
    "Invoice no.": "Рахунок-фактура No",
    "Login options": "Варіанти входу",
    "Tenant ID (optional)": "Ідентифікатор клієнта (необов'язково)",
    "Add Active Directory tenant ID, if only users belonging to this tenant are allowed to connect": "Додайте ідентифікатор клієнта Active Directory, якщо до підключення дозволено підключатися лише користувачам, які належать до цього клієнта",
    "How to find ID’s?": "Як знайти посвідчення особи?",
    "Microsoft connected": "Корпорація Майкрософт",
    "Google connected": "Зв'язок з Google",
    "Edit company": "Редагувати компанію",
    "Timezone": "Часовий пояс",
    "Invoice email": "Електронний лист із рахунком-фактурою",
    "Subscription plan": "План передплати",
    "Payment failed": "Не вдалося здійснити платіж",
    "Retry payment": "Повторна спроба оплати",
    "Next payment": "Наступний платіж",
    "Update payment method": "Як оновити спосіб оплати",
    "Plan": "Тариф",
    "Choose a plan": "Оберіть тарифний план",
    "Change plan": "Змінити план",
    "{0}-day free trial until {1}": "{0}-денна безкоштовна пробна версія до {1}",
    "monthly": "щомісячно",
    "yearly": "щорічно",
    "{0} member": "{0} учасник",
    "{0} members": "{0} учасників",
    "{0} plan": "{0} план",
    "Cancelled (valid until {0})": "Скасовано (діє до {0})",
    "Your trial expired on {0}": "Термін дії пробної версії закінчився {0}",
    "Your subscription expired on {0}": "Термін дії вашої підписки закінчився {0}",
    "It’s nice to see you! If you'd like to get up and running with a Uku subscription, click Choose a plan": "Приємно вас бачити! Якщо ви хочете розпочати роботу з підпискою Uku, натисніть Вибрати план",
    "Save {0} by paying for a year!": "Заощаджуйте {0}, сплативши за рік!",
    "Choose plan": "Оберіть тариф",
    "Pay annually": "Сплачуйте щорічно",
    "Instructions sent!": "Інструкції надіслано!",
    "Instructions for resetting your password have been sent to": "Інструкції щодо скидання пароля надіслано на адресу",
    "You’ll receive this email within 5 minutes. Be sure to check your spam folder, too.": "Ви отримаєте цей лист протягом 5 хвилин. Також не забудьте перевірити папку зі спамом.",
    "Back to login page": "Повернутися до сторінки входу",
    "Get new password": "Отримати новий пароль",
    "Pick a password": "Виберіть пароль",
    "Use minimum 8 characters with letters & numbers": "Використовуйте мінімум 8 символів із літерами та цифрами",
    "Create your Uku Account": "Створіть свій обліковий запис Uku",
    "Connect your Xero Account": "Підключіть свій обліковий запис Xero",
    "Phone": "Телефон",
    "I agree to the": "Я погоджуюся з",
    "Terms of Service": "Умови обслуговування",
    "Next": "Далі",
    "Having trouble?": "Виникли проблеми?",
    "We can help": "Ми можемо допомогти",
    "Log in instead": "Увійдіть до системи",
    "You are invited to join": "Запрошуємо вас приєднатися",
    "Accept invitation": "Прийняти запрошення",
    "Check your email": "Перевірити свою електронну пошту",
    "I sent you an email with a link to activate your account. This is important to ensure the security of your account.": "Я надіслав вам листа з посиланням для активації облікового запису. Це важливо для забезпечення безпеки вашого облікового запису.",
    "Go to": "Перейти",
    "Need a new password?": "Потрібен новий пароль?",
    "Enter your e-mail address and we will send you directions for changing your password": "Введіть свою адресу електронної пошти, і ми надішлемо вам вказівки щодо зміни пароля",
    "Send me instructions": "Надішліть мені інструкції",
    "Never mind, go back": "Нічого, поверніться назад",
    "No login options enabled. Please contact the company owner": "Опції входу не ввімкнені. Будь ласка, зв'яжіться з власником компанії",
    "Log in to Uku": "Увійдіть в Uku",
    "Forgot password?": "Забули пароль?",
    "Don't have account?": "У вас немає облікового запису?",
    "Create account": "Створити акаунт",
    "No. 1 tool for accounting practices. Automated workflows, time tracking, reports, monitoring, CRM. Get work done on time & profitably. Try for free!": "Інструмент No1 для бухгалтерської практики. Автоматизація документообігу, облік робочого часу, звіти, моніторинг, CRM. Виконуйте роботу вчасно та з користю. Спробуйте безкоштовно!",
    "Total items:": "Всього товарів:",
    "Add new": "Додати",
    "Amount": "Сума",
    "Account created range": "Діапазон створених облікових записів",
    "Usage limit": "Обмеження по використанню",
    "Valid until": "Дійсний до",
    "Edit help link": "Редагувати посилання на довідку",
    "New help link": "Нове довідкове посилання",
    "Name key": "Ключ імені",
    "Country code": "Код країни",
    "Period (months)": "Період (місяців)",
    "Account created from": "Обліковий запис, створений з",
    "Account created until": "Обліковий запис створено до",
    "Used count": "Кількість використаних",
    "Free days": "Free days",
    "Sum": "Сума",
    "Create voucher": "Створити ваучер",
    "Edit voucher": "Редагувати ваучер",
    "Are you sure to delete this voucher?": "Ви впевнені, що видалили цей ваучер?",
    "row | rows": "рядок | Рядки",
    "Add event": "Додати подію",
    "Are you sure you wish to delete this event?": "Ви впевнені, що хочете видалити цю подію?",
    "event | events": "подія | Події",
    "Security object id": "Ідентифікатор об'єкта безпеки",
    "Direct rights": "Прямі права",
    "Computed rights": "Обчислювані права",
    "Add link": "Додати посилання",
    "Are you sure you wish to delete this entry?": "Ви впевнені, що хочете видалити цей запис?",
    "link | links": "посилання | Посилання",
    "Event type": "Тип події",
    "Date from": "Дата з",
    "Date until": "Дата до",
    "Shortened by h": "Скорочено на h",
    "Category": "Категорія",
    "demo | demos": "демонстрація | Демо",
    "Created at": "Created at",
    "Invited by": "Invited by",
    "referral | referrals": "referral | referrals",
    "Companies": "Компанії",
    "Leads": "Відведення",
    "Demos": "Демо",
    "Vouchers": "Ваучери",
    "KPI": "KPI",
    "Referrals": "Referrals",
    "Activity log": "Журнал активності",
    "Notifications": "Сповіщення",
    "Me": "Мене",
    "Important notifications will appear here.": "Тут з'являться важливі повідомлення.",
    "Back": "Назад",
    "Return to UKU": "Повернення в УКУ",
    "Choose plan for {0}": "Оберіть тарифний план для {0}",
    "First payment will be made after the end of the trial period.": "Перший платіж буде здійснено після закінчення пробного періоду.",
    "Members and subscription can always be changed.": "Учасників та підписку завжди можна змінити.",
    "Your subscription is externally managed by Xero": "Your subscription is externally managed by Xero",
    "Select plan": "Select plan",
    "Billing period": "Розрахунковий період",
    "Compare features": "Порівняйте характеристики",
    "Cancel uku subscription": "Скасувати підписку uku",
    "{0} discount": "{0} знижка",
    "You have currently<br />{0} active member": "На даний момент у вас є<br />{0} Активний учасник",
    "You have currently<br />{0} active members": "На даний момент у вас є<br />{0} Активні учасники",
    "Select yearly plan": "Оберіть річний план",
    "Select monthly plan": "Виберіть місячний план",
    "Attention!": "Увага!",
    "Plan change request": "Plan change request",
    "If you want to use Uku for free then deactivate your account and continue with {0} plan": "Якщо ви хочете використовувати Uku безкоштовно, деактивуйте свій обліковий запис і продовжуйте користуватися {0} планом",
    "per member/month (billed yearly)": "за учасника на місяць (щорічна оплата)",
    "or {0} per member/month (monthly)": "або {0} на кожного учасника на місяць (щомісяця)",
    "Everything in {0}, plus:": "Все в {0}, плюс:",
    "Compare plans, feature-by-feature": "Порівняйте тарифні плани за функціями",
    "Deactivate account": "Деактивувати обліковий запис",
    "Are you sure to deactivate {0} account?": "Ви впевнені, що деактивуєте {0} обліковий запис?",
    "If you choose to continue with freelancer plan your company account will be deactivated. Data that is related to this company will be removed.": "Якщо ви вирішите продовжити роботу з тарифним планом фрілансера, обліковий запис вашої компанії буде деактивовано. Дані, пов'язані з цією компанією, будуть видалені.",
    "Deactivate": "Деактивувати",
    "Teamwork": "Спільної роботи",
    "Unlimited clients + import": "Необмежена кількість клієнтів + імпорт",
    "Access management": "Управління доступом",
    "Custom fields": "Спеціальні поля",
    "Live chat support": "Підтримка в онлайн-чаті",
    "AML": "AML",
    "API": "Ключ API карти Google",
    "Client Portal": "WorkWeb Host",
    "New!": "Новий!",
    "Custom integrations": "Кастомні інтеграції",
    "Assisted clients import": "Імпорт допоможних клієнтів",
    "Tailor-made team workshop": "Індивідуальна командна майстерня",
    "Early access to features": "Ранній доступ до функцій",
    "Pay by invoice": "Оплата за рахунком",
    "Dedicated account manager": "Персональний менеджер по роботі з клієнтами",
    "Hi! Your trial is over. Please choose {0} subscription plan to continue work": "Привіт! Ваш пробний період закінчився. Будь ласка{0} оберіть тарифний план, щоб продовжити роботу",
    "Hi! You need to upgrade {0} subscription plan to use that feature": "Привіт! Щоб скористатися цією функцією, вам потрібно оновити план підписки {0}",
    "Waiting for the subscription to complete": "Waiting for the subscription to complete",
    "VAT": "ПДВ",
    "This is subscription period amount.": "Це сума періоду підписки.",
    "You save yearly {0}": "Ви заощаджуєте щорічні {0}",
    "Add voucher": "Додати ваучер",
    "Existing credit": "Існуючий кредит",
    "Current payment": "Поточна оплата",
    "This is the current payment amount. Your bank also requires confirmation for the subscription period amount.": "Це поточна сума платежу. Ваш банк також вимагає підтвердження суми періоду підписки.",
    "Confirm subscription {0}": "Підтвердьте підписку {0}",
    "Your subscription will renew on": "Ваша підписка буде продовжена на",
    "Thank you for believing in us!": "Дякуємо, що вірите в нас!",
    "Uku team": "Команда УКУ",
    "Voucher {1} (-{0}%)": "Ваучер {1} (-{0}%)",
    "Voucher {0}": "Ваучер {0}",
    "New plan": "Новий план",
    "Changed plan": "Змінений план",
    "Add {0} member": "Додати {0} учасника",
    "Add {0} members": "Додати {0} учасників",
    "Remove {0} member": "Вилучити {0} учасника",
    "Remove {0} members": "Як вилучити учасників {0}",
    "No changes to plan": "Без змін у плані",
    "Discount -{0}% with Yearly subscription": "Знижка -{0}% при оформленні річної підписки",
    "Yearly discounted price (-{0}%)": "Річна ціна зі знижкою (-{0}%)",
    "Subscription updated": "Підписка оновлена",
    "Please wait": "Зачекайте, будь ласка",
    "Your payment failed": "Платіж не здійснено",
    "Please check that you entered the data correctly or use another card": "Будь ласка, перевірте, чи правильно ви ввели дані, або скористайтесь іншою карткою",
    "Try again": "Пробуйте знову",
    "Pay": "Оплатити",
    "Payment": "Оплата",
    "Payment method updated": "Спосіб оплати оновлений",
    "Edit member": "Редагувати учасника",
    "First name": "Ім'я",
    "Last name": "Прізвище",
    "External ID": "Зовнішній ідентифікатор",
    "Select groups": "Вибір груп",
    "Administrator": "Адміністратор",
    "Activate member": "Активувати учасника",
    "Deactivate member": "Деактивувати учасника",
    "Paid member": "Платний учасник",
    "Send an invitation": "Надсилання запрошення",
    "Limited": "Обмежений",
    "No invite, no access": "Немає запрошення, немає доступу",
    "Free until activated": "Безкоштовно до активації",
    "No access, no charge": "Немає доступу, немає плати",
    "Hidden member": "Прихований учасник",
    "Edit members": "Редагування учасників",
    "Select user": "Оберіть користувача",
    "Member will be assigned to every selected client": "Учасник буде закріплений за кожним обраним клієнтом",
    "Member will be removed from all selected clients": "Учасник буде видалений з усіх обраних клієнтів",
    "Assign user": "Призначити користувача",
    "Set as primary user": "Установлено основним користувачем",
    "Added as a default user when adding a task plan": "Додано як користувача за замовчуванням під час додавання плану завдань",
    "Remove from new tasks": "Видалення з нових завдань",
    "Remove from plan tasks": "Видалення завдань із плану",
    "Remove": "Видалити",
    "Admin": "Адміністратор",
    "Remove user": "Видалити користувача",
    "Assign to incomplete tasks": "Призначати невиконаним завданням",
    "Reassign incomplete tasks": "Перепризначення незавершених завдань",
    "Assign to plan tasks": "Призначайте планові завдання",
    "Reassign plan tasks": "Перепризначення завдань плану",
    "Owner will be assigned to tasks if the removed user was the last assigned user.": "Власнику буде призначено завдання, якщо видалений користувач був останнім призначеним користувачем.",
    "Run integration": "Запустіть інтеграцію",
    "Run": "Запуск",
    "Integration configuration": "Конфігурація інтеграції",
    "Read the manual": "Прочитайте інструкцію",
    "Api key": "Ключ API",
    "Are you sure to delete this integration info?": "Ви впевнені, що видалили цю інформацію про інтеграцію?",
    "Edit Contracts": "Редагувати договори",
    "Replace following contracts": "Замініть наступні договори",
    "Append services to following contracts": "Додавання послуг до наступних договорів",
    "Choose template": "Виберіть шаблон",
    "Append only": "Лише додавання",
    "with template": "з шаблоном",
    "All existing contracts": "Всі існуючі договори",
    "All quarterly contracts": "Всі квартальні договори",
    "All monthly contracts": "Всі місячні контракти",
    "All yearly contracts": "Всі річні контракти",
    "Next invoice number": "Наступний номер рахунка-фактури",
    "Number is too big, it cannot exceed 15 digits": "Число занадто велике, воно не може перевищувати 15 цифр",
    "Replace topic": "Замінити тему",
    "All tasks and plans with current topic will be replaced with the new selected topic.": "Всі завдання і плани з актуальною темою будуть замінені на нову обрану тему.",
    "Topics replaced": "Замінено теми",
    "All tasks with the topic `{0}` will be replaced with `{1}`. This is not reversible. Are you sure?": "Усі завдання з темою «{0}» буде замінено на «{1}». Це не є оборотним. Ти впевнений?",
    "Name of topic": "Назва теми",
    "New time entries will be marked as non-billable": "New time entries will be marked as non-billable",
    "Change topic": "Змінити тему",
    "Add new topic": "Додати нову тему",
    "This topic is in use. Do you wish to archive it?": "Ця тема у використанні. Бажаєте заархівувати його?",
    "Are you sure that you want to delete this topic?": "Ви впевнені, що хочете видалити цю тему?",
    "These items will be deleted permanently": "Ці елементи будуть видалені назавжди",
    "Are you sure that you want to delete this client group?": "Ви впевнені, що хочете видалити цю групу клієнтів?",
    "This client group is in use. Do you wish to archive it?": "Ця група клієнтів використовується. Бажаєте заархівувати його?",
    "Edit client group": "Редагування групи клієнтів",
    "New client group": "Нова група клієнтів",
    "Price": "Ціна",
    "Quantity": "Кількість",
    "Unit will be translated to client language": "Одиниця буде перекладена на мову клієнта",
    "Pick date & time": "Виберіть дату й час",
    "Share equally": "Діліться порівну",
    "Change existing": "Змінити існуючі",
    "Choose bookmark": "Виберіть закладку",
    "New title": "Нова назва",
    "Set as my default view": "Установити як подання за умовчанням",
    "Signature name": "Signature name",
    "Layout": "Layout",
    "Top": "Top",
    "Middle": "Middle",
    "Bottom": "Bottom",
    "Logo left": "Logo left",
    "Logo top": "Logo top",
    "No logo": "No logo",
    "Linkedin": "Linkedin",
    "Facebook": "Facebook",
    "Email signature": "Email signature",
    "Edit email signature": "Edit email signature",
    "Add email signature": "Add email signature",
    "Font color": "Font color",
    "Actions": "Дії",
    "Delete signature": "Delete signature",
    "Do you wish to update related contracts and invoices?": "Бажаєте оновити пов'язані договори та рахунки-фактури?",
    "Update contract templates, active contracts and open invoices.": "Оновлюйте шаблони договорів, активні договори та відкриті інвойси.",
    "The following fields will be updated": "Наступні поля будуть оновлені",
    "Custom Value": "Спеціальна вартість",
    "This product is in use. Do you wish to archive it?": "Цей продукт використовується. Бажаєте заархівувати його?",
    "Are you sure that you want to delete this product?": "Ви впевнені, що хочете видалити цей продукт?",
    "Customize for client": "Налаштувати під клієнта",
    "Customize for template": "Налаштувати для шаблону",
    "Open product template": "Відкрити шаблон товару",
    "Create product template": "Створити шаблон продукту",
    "Master template": "Майстер-шаблон",
    "Client product": "Клієнтський продукт",
    "Client product / service": "Клієнтський товар / послуга",
    "New client product": "Новий клієнтський продукт",
    "Template product": "Шаблонний продукт",
    "Template product / service": "Шаблон товару / послуги",
    "New template product": "Новий шаблонний продукт",
    "Edit translations": "Редагування перекладів",
    "Billable topics": "Оплачувані теми",
    "Billable time": "Оплачуваний час",
    "Minimum quantity": "Мінімальна кількість",
    "Minimum time": "Мінімум часу",
    "Integration parameters": "Параметри інтеграції",
    "Empty values will use product default": "Порожні значення використовуватимуть продукт за замовчуванням",
    "Pricing": "Ціна",
    "DC %": "Зниж. %",
    "Sum all matching rows": "Сума всіх рядків, що збігаються",
    "When enabled, total price is a cumulative sum of all matching rows. By default, total price price only uses the highest matching row.": "Якщо цей параметр увімкнено, загальна ціна є сукупною сумою всіх рядків, що збігаються. За умовчанням для загальної ціни використовується лише найвищий відповідний рядок.",
    "Prices since": "Ціни з",
    "Add price": "Додати ціну",
    "Add pricing period": "Додати період ціноутворення",
    "Update contracts": "Оновити договори",
    "(Without topic)": "(Без теми)",
    "Fixed price": "Фіксована ціна",
    "Product": "Товар",
    "Event created": "Подія створена",
    "Project created": "Проект створено",
    "Event deleted": "Подію видалено",
    "Project deleted": "Проект видалено",
    "Workflow added": "Додано робочий процес",
    "Workflow removed": "Робочий процес видалено",
    "Workflow updated": "Робочий процес оновлено",
    "Event cancelled": "Подію скасовано",
    "Project cancelled": "Проект скасовано",
    "Event reactivated": "Подію повторно активовано",
    "Project reactivated": "Проект відновлено",
    "Event archived": "Архів події",
    "Project archived": "Проект заархівовано",
    "Event unarchived": "Подія без архіву",
    "Project unarchived": "Проект без архіву",
    "Event changed": "Подія змінилася",
    "Project changed": "Проект змінено",
    "Event status changed: {0}": "Змінено статус події: {0}",
    "Project status changed: {0}": "Статус проекту змінено: {0}",
    "Event status changed": "Змінено статус події",
    "Project status changed": "Статус проекту змінено",
    "Task created": "Завдання створено",
    "Task changed": "Завдання змінено",
    "Task finished": "Завдання виконано",
    "Task not finished": "Завдання не виконано",
    "Task deleted": "Завдання видалено",
    "Add project": "Додати проект",
    "Hide filters": "Сховати фільтри",
    "Show filters": "Показати фільтри",
    "Cancel event": "Скасувати подію",
    "Cancel project": "Скасувати проект",
    "Manage event fields": "Керування полями подій",
    "Manage project fields": "Керування полями проекту",
    "New event": "Нова подія",
    "New project": "Новий проект",
    "{0} (Copy)": "{0} (копія)",
    "Are you sure you wish to delete this project?": "Ви впевнені, що хочете видалити цей проект?",
    "Are you sure to archive this event?": "Ви обов'язково заархівували цю подію?",
    "Are you sure to archive this project?": "Ви впевнені, що заархівували цей проект?",
    "Are you sure to cancel this event?": "Ви впевнені, що скасуєте цю подію?",
    "Are you sure to cancel this project?": "Ви впевнені, що скасуєте цей проект?",
    "Communication": "Зв'язок",
    "Log": "Журнал",
    "Create event workflow": "Створення робочого процесу події",
    "Create project workflow": "Створення робочого процесу проекту",
    "Use workflow templates to set up tasks effectively or": "Використовуйте шаблони робочих процесів для ефективного налаштування завдань або",
    "Add tasks manually": "Додавайте завдання вручну",
    "Save bookmark": "Зберегти закладку",
    "Remove filters": "Видаліть фільтри",
    "Filter": "Фільтр",
    "Show multiselect": "Показати мультиселект",
    "To do today": "Що зробити сьогодні",
    "This and next month": "Цього і наступного місяця",
    "Last 3 months": "Останні 3 місяці",
    "Next 3 months": "Наступні 3 місяці",
    "Starts": "Починається",
    "To do": "Що робити",
    "today": "сьогодні",
    "tomorrow": "завтра",
    "yesterday": "вчора",
    "Previous week": "Попередній тиждень",
    "Group similar tasks": "Групуйте схожі завдання",
    "Group by client": "Група за клієнтом",
    "Group by date": "Групування за датою",
    "Group by topic": "Групування за темами",
    "Are you sure to remove google?": "Ви впевнені, що видалили google?",
    "Google log in": "Увійти в Google",
    "Microsoft log in": "Вхід до системи Microsoft",
    "Are you sure to remove microsoft?": "Ви впевнені, що видалили Microsoft?",
    "Are you want to disconnect Xero?": "Are you want to disconnect Xero?",
    "Reset password": "Reset password",
    "Your details": "Ваші подробиці",
    "City": "Місто",
    "Regional format": "Регіональний формат",
    "Default company": "Компанія за замовчуванням",
    "Lock time entries notification": "Сповіщення про блокування записів часу",
    "Notify by": "Сповістити",
    "Delete my account": "Видалити мій обліковий запис",
    "Attention": "Увага",
    "Are you sure that you want to delete your account?": "Ви впевнені, що хочете видалити свій обліковий запис?",
    "Notification": "Повідомлення",
    "Notification & email": "Сповіщення та електронна пошта",
    "Vacations / absence": "Відпустки / відсутність",
    "Edit balance": "Редагувати баланс",
    "View history": "Перегляд історії",
    "Request": "Запит",
    "How long": "Як довго",
    "Requested": "Запитаний",
    "Approved": "Підтвердженно",
    "Rejected": "Відхилено",
    "In review": "Рецензія",
    "Change": "Змінити",
    "Agreements": "Угода",
    "New agreement": "Нова угода",
    "Change agreement": "Змінити угоду",
    "Stop demo": "Зупинити демо",
    "Show": "Показати",
    "Don't show": "Не показувати",
    "Don't send": "Не надсилати",
    "Email workdays at 7 AM": "Робочу пошту о 7 ранку",
    "Email at 3 PM": "Електронна пошта о 15:00",
    "Email at once": "Електронна пошта одразу",
    "Email Sundays at 11 PM": "Електронна пошта по неділях об 11 вечора",
    "First day of the month": "Перший день місяця",
    "to email": "на електронну пошту",
    "E-mail at once": "Електронна пошта відразу",
    "System": "Система",
    "Person": "Особа",
    "Picture": "Зображення",
    "Time zone": "Часовий пояс",
    "Calendar settings": "Налаштування календаря",
    "Public holidays": "Державні свята",
    "Tax deadlines": "Податкові строки",
    "News": "Новини",
    "External services": "Зовнішні сервіси",
    "Agreement": "Угода",
    "Active agreement": "Активна угода",
    "Weekly hours": "Тижневий графік роботи",
    "Edit supplier": "Редагувати постачальника",
    "New supplier": "Новий постачальник",
    "Are you sure you wish to delete this supplier?": "Ви впевнені, що хочете видалити цього постачальника?",
    "Add supplier": "Додати постачальника",
    "Supplier types are not defined. Please go to the suppliers app settings to add.": "Типи постачальників не визначені. Будь ласка, перейдіть до налаштувань програми постачальників, щоб додати.",
    "No members yet": "Ще немає учасників",
    "Edit group": "Група редагування",
    "Add group": "Додати групу",
    "Are you sure to delete this user group?": "Ви впевнені, що видалили цю групу користувачів?",
    "Get set up to work with team": "Налаштуйтеся на роботу з командою",
    "Company account allows you to use tools for teams, get deeper insights etc. Raise the quality of your team's workflow and lead a more profitable business.": "Обліковий запис компанії дозволяє використовувати інструменти для команд, отримувати глибшу інформацію тощо. Підвищуйте якість робочого процесу вашої команди та ведіть більш прибутковий бізнес.",
    "Create company account": "Створити обліковий запис компанії",
    "By creating a company account you activate Uku free subscription for {0} days.": "Створюючи обліковий запис компанії, ви активуєте безкоштовну підписку Uku на {0} днів.",
    "You have invited {0}/{1} members": "Ви запросили {0}/{1} учасників",
    "Upgrade": "Оновити",
    "View profile": "Перегляд профілю",
    "To add members to your team, you'll need to create a company account": "Щоб додати учасників до команди, потрібно створити обліковий запис компанії",
    "Export": "Експорт",
    "Re-invite sent": "Повторне запрошення надіслано",
    "View report": "Переглянути звіт",
    "Member {0} will be deactivated.": "Учасник {0} буде деактивовано.",
    "Please select new member who will replace {0}.": "Будь ласка, оберіть нового учасника, який замінить {0}.",
    "Select new member": "Виберіть нового учасника",
    "NB! Deactivation process cannot be reversed": "Важливо! Процес деактивації не можна скасувати",
    "Magic button settings": "Налаштування чарівної кнопки",
    "Create only one task per month": "Створюйте лише одне завдання на місяць",
    "Current month's tasks": "Завдання поточного місяця",
    "extra work": "додаткова робота",
    "Without topic": "Без теми",
    "Week": "Тиждень",
    "Previous month": "Попередній місяць",
    "task | tasks": "завдання | Завдання",
    "Assign to": "Призначити для",
    "Mark as done": "Позначити як виконано",
    "Last": "Останній",
    "Snooze": "Повтору",
    "1 dependency": "1 Залежність",
    "{0} dependencies": "{0} залежностей",
    "Client request": "Запит клієнта",
    "Unread notification emails": "Unread notification emails",
    "Unread internal comments": "Unread internal comments",
    "Add comment": "Додати коментар",
    "Internal comment": "Внутрішній коментар",
    "Portal message": "Повідомлення порталу",
    "Public message means that clients can read it and the client portal will notify them by email": "Публічне повідомлення означає, що клієнти можуть його прочитати, а клієнтський портал повідомить їх електронною поштою",
    "Type a comment": "Введіть коментар",
    "Send portal message": "Надіслати повідомлення порталу",
    "Open timesheet": "Відкрити табель обліку робочого часу",
    "Pause timer": "Таймер паузи",
    "Mark undone": "Позначити скасовано",
    "Digitise": "Оцифрування",
    "Documents sent to digitisation": "Документи, відправлені в цифровізацію",
    "Followers": "Підписники",
    "Start / Due date": "Дата початку / завершення",
    "Select topic": "Оберіть тему",
    "1 document": "1 документ",
    "{0} documents": "{0} документів",
    "Download": "Завантажити",
    "Download all": "Завантажити все",
    "Primary contact": "Primary contact",
    "Assign as task": "Призначити як завдання",
    "When selected, the task is sent as a task to the client": "При виборі завдання відправляється як завдання клієнту",
    "Auto finish": "Автоматична обробка",
    "When selected, the task is marked done after client finishes it": "При виборі завдання позначається як виконане після того, як клієнт його завершить",
    "Add comment / message": "Додати коментар / повідомлення",
    "Add email": "Додати Email",
    "Add estimation": "Додати оцінку",
    "Add task field": "Додати поле завдання",
    "Add dependency": "Додати залежність",
    "Drop files to upload": "Видаліть файли для завантаження",
    "Task sent to client portal": "Завдання відправлено на клієнтський портал",
    "Task no longer assigned to client portal": "Завдання більше не призначено на клієнтський портал",
    "Save recurring task": "Збереження повторюваних завдань",
    "Add to-do list": "Додати список справ",
    "Waiting for event status: {0}": "В очікуванні статусу події: {0}",
    "Waiting for project status: {0}": "В очікуванні статусу проекту: {0}",
    "Edit template task": "Редагувати шаблонне завдання",
    "Create recurring task": "Створення повторюваних завдань",
    "Make a copy": "Зробити копію",
    "Add topic": "Додати тему",
    "Delete task": "Видалити завдання",
    "Delete task template": "Видалити шаблон завдання",
    "Select task field": "Виберіть поле завдання",
    "No custom fields available for this client": "Для цього клієнта немає кастомних полів",
    "task": "завдання",
    "recurring task": "Повторюване завдання",
    "Do you intend to remove yourself from {0} or you want to delete it completely?": "Ви маєте намір видалити себе з {0} або хочете видалити його повністю?",
    "This {1} is shared with {0}": "Цим {1} ділиться з {0}",
    "Remove only me": "Вилучити лише мене",
    "Time has been tracked to this task.": "Для виконання цього завдання було відстежено час.",
    "Are you sure to delete this task?": "Ви впевнені, що видалите це завдання?",
    "Undefined": "Невизначена",
    "COPY": "КОПІЮВАТИ",
    "On task due date": "Про дату виконання завдання",
    "{0} day before": "{0} день напередодні",
    "{0} days before": "{0} днів до",
    "Edit workflow": "Редагування робочого процесу",
    "Duplicate project": "Дублювати проект",
    "Reset layout": "Скидання макета",
    "Any time": "У будь-який час",
    "1 min": "1 хв",
    "5 min": "5 хв",
    "10 min": "10 хв",
    "30 min": "30 хв",
    "1 h": "1 год",
    "Add notes": "Додавання нотаток",
    "Task start date": "Дата початку виконання завдання",
    "Task due date": "Термін виконання завдання",
    "Recurrence task": "Завдання на повторення",
    "Search from one time templates": "Пошук за одноразовими шаблонами",
    "Placeholders": "Заповнювачі",
    "New task": "Нове завдання",
    "New recurring task": "Нове повторюване завдання",
    "+1 day": "+1 доб.",
    "Edit comment": "Редагувати коментар",
    "Timer is running!": "Таймер працює!",
    "Continue time from {0}": "Продовжити час з {0}",
    "New time entry": "Запис у новому часі",
    "Load more": "Завантажити більше",
    "Are you sure to delete this time entry?": "Ви впевнені, що видалите цей запис часу?",
    "Save automated email": "Зберігайте автоматичну електронну пошту",
    "Automation": "Автоматизація",
    "Are you sure to delete this email?": "Ви впевнені, що видалили цей лист?",
    "Are you sure you wish to send this email immediately?": "Ви впевнені, що хочете надіслати цей лист негайно?",
    "replied to project email": "replied to project email",
    "replied to client email": "replied to client email",
    "commented": "прокоментоване",
    "Reply": "Відповісти",
    "Are you sure to delete this comment?": "Ви впевнені, що видалили цей коментар?",
    "replied to client portal email": "replied to client portal email",
    "sent a message": "надіслали повідомлення",
    "replied to task email": "replied to task email",
    "failed to send": "не вдалося відправити",
    "sent email": "надіслано електронною поштою",
    "no one": "Ніхто",
    "created this task.": "створив це завдання.",
    "Task was automatically created from forwarded e-mail": "Task was automatically created from forwarded e-mail",
    "Task was automatically created from client portal e-mail": "Task was automatically created from client portal e-mail",
    "Task was automatically created from client e-mail": "Task was automatically created from client e-mail",
    "Task was automatically created from project e-mail": "Task was automatically created from project e-mail",
    "requested assistance.": "звернувся за допомогою.",
    "updated this task.": "оновив це завдання.",
    "tracked time to this task.": "відстежував час виконання цього завдання.",
    "finished this task.": "впорався з цим завданням.",
    "new comment.": "новий коментар.",
    "reassigned this task.": "перепризначив це завдання.",
    "assigned the task to {0}.": "доручив завдання {0}.",
    "reminder.": "Нагадування.",
    "deleted.": "Видалені.",
    "completed the task, but Uku did not auto-finish this task because not all task requirements were met.": "виконали завдання, але Uku не завершив це завдання автоматично, оскільки не всі вимоги до завдання були виконані.",
    "sent task to client portal": "Надіслано завдання на портал клієнта",
    "assigned the task to client.": "доручив завдання клієнту.",
    "assigned the task to company.": "доручив завдання компанії.",
    "added attachment(s).": "додано вкладення.",
    "added a comment.": "– додав коментар.",
    "added a message to {0}.": "Додано повідомлення до {0}.",
    "received a e-mail from {0}.": "received a e-mail from {0}.",
    "updated notes.": "оновлені нотатки.",
    "made changes to checklist.": "внесли зміни до чек-листа.",
    "created this task template.": "створив цей шаблон завдання.",
    "updated this task template.": "оновив цей шаблон завдання.",
    "recurring task assigned.": "призначене повторюване завдання.",
    "recurring task deleted.": "Повторюване завдання видалено.",
    "added email.": "додано електронну пошту.",
    "changed email.": "Змінено адресу електронної пошти.",
    "deleted email.": "видалений електронний лист.",
    "sent email.": "надіслав електронний лист.",
    "failed to send.": "не вдалося відправити.",
    "added email": "Додана електронна пошта",
    "changed email": "Змінено адресу електронної пошти",
    "deleted email": "Видалений електронний лист",
    "Member / Time": "Учасник / Час",
    "Client/topic": "Клієнт/тема",
    "Client/task": "Клієнт/завдання",
    "Client/member": "Клієнт/учасник",
    "Member/topic": "Учасник/тема",
    "Member/task": "Учасник/завдання",
    "Member/client": "Учасник/клієнт",
    "Member/date": "Учасник/дата",
    "Date/member": "Дата/учасник",
    "Grouped": "Згрупований",
    "Client/project": "Клієнт/проект",
    "Project/member": "Проект/учасник",
    "Period balance": "Сальдо періоду",
    "Reset balance": "Скидання балансу",
    "Time entry has been confirmed or duration has been changed and duration will not dynamically update": "Введений час підтверджено або тривалість змінено, і тривалість не оновлюється динамічно",
    "(Without project)": "(Без проекту)",
    "Decline": "Відхилити",
    "Accept": "Прийняти",
    "Cancel decision": "Скасувати рішення",
    "Accepted": "Прийнятий",
    "Declined": "Відхилено",
    "Report data has changed. Please update report.": "Дані звіту змінилися. Будь ласка, оновіть звіт.",
    "Agreed": "Погоджено",
    "Non billable": "Не підлягає оплаті",
    "Estimation report shows based on task start date": "Estimation report shows based on task start date",
    "Export report to Excel": "Експорт звіту в Excel",
    "By default, we export the result of the selected filters with the columns of the configured table": "За замовчуванням ми експортуємо результат обраних фільтрів зі стовпцями налаштованої таблиці",
    "Add to export client custom fields": "Додати до експорту користувацькі поля клієнта",
    "Save report": "Зберегти звіт",
    "Export PDF": "Експорт PDF-файлу",
    "Export Excel": "Експорт Excel",
    "Extra": "Додатково",
    "done": "готово",
    "h": "h",
    "We have new version of": "У нас з'явилася нова версія",
    "Log out": "Вийти",
    "Previous day": "Попередній день",
    "Next day": "Наступного дня",
    "Mark all as read": "Позначити все як прочитане",
    "Search task/client": "Пошук завдання/клієнта",
    "from client portal": "з клієнтського порталу",
    "Hide all": "Сховати все",
    "Hide for 1 hour": "Сховати на 1 годину",
    "Something went wrong": "Щось пішло не так",
    "User authentication needed": "Потрібна автентифікація користувача",
    "Invalid rights": "Недійсні права",
    "The object cannot be found": "Об'єкт не знайдено",
    "Content too large": "Занадто великий контент",
    "An unknown error occurred": "Сталася невідома помилка",
    "The action requested cannot be performed": "Запитувана дія не може бути виконана",
    "Go": "Перейти",
    "Actual / monitoring (month)": "Фактичний / моніторинг (місяць)",
    "Actual": "Фактичний",
    "Month": "Місяць",
    "I’m setting up your account": "Я налаштовую ваш обліковий запис",
    "Did you know that accounting firms that have started using Uku can serve 38% more clients in the same time.": "Чи знаєте ви, що бухгалтерські фірми, які почали використовувати UKU, можуть обслуговувати на 38% більше клієнтів за той же час.",
    "Let’s setup your company": "Створимо вашу компанію",
    "Name of your company": "Назва вашої організації",
    "Size of your team?": "Розмір вашої команди?",
    "Which software are you using?": "Яке програмне забезпечення ви використовуєте?",
    "This knowledge will help us to improve Uku": "Ці знання допоможуть нам покращити Уку",
    "What other software needs to be integrated?": "Яке ще програмне забезпечення потрібно інтегрувати?",
    "Book a demo": "Замовити демо",
    "Hi {0},": "Привіт, {0}!",
    "NO BOTS - ONLY HUMANS": "НІЯКИХ БОТІВ - ТІЛЬКИ ЛЮДИ",
    "Start a {0} day free trial": "Start a {0} day free trial",
    "“Uku is an incredibly functional software. Uku boosted our work management and helps us provide exceptional service.”": "«Uku – це неймовірно функціональне програмне забезпечення. Uku покращив наше управління роботою та допомагає нам надавати винятковий сервіс».",
    "The fastest way for you to decide if Uku can benefit {0} is a short {1} min call with our customer onboarding specialist.": "Найшвидший спосіб вирішити, чи може Uku принести {0} користь, — це короткий {1}-хвилинний дзвінок з нашим фахівцем з адаптації клієнтів.",
    "Hi, I'm Uku ": "Привіт, мене звати Уку ",
    "I help to set up your account.": "Допомагаю налаштувати ваш обліковий запис.",
    "It only takes a minute.": "Це займе всього хвилину.",
    "Choose": "Виберіть",
    "Your country": "Твоя країна",
    "Your language": "Ваша мова",
    "Begin": "Починатися",
    "Let’s become friends": "Давайте дружити",
    "Your first name": "Ваше ім'я",
    "What is your field of work?": "Яка ваша сфера діяльності?",
    "Your field of work": "Ваша сфера діяльності",
    "How will you use Uku?": "Як ви будете використовувати Uku?",
    "How did you hear about Uku?": "Як ви дізналися про Уку?",
    "Choose channel": "Оберіть канал",
    "Please specify how you heard about us": "Вкажіть, будь ласка, як ви про нас дізналися",
    "Let me know Uku's new features by email": "Повідомте мені про нові функції Uku електронною поштою",
    "Finish": "Завершити",
    "First name is required": "Ім’я обов’язкове",
    "Name is required": "Ім'я є обов'язковим",
    "Team size is required": "Обов'язковий розмір команди",
    "Surname is required": "Прізвище обов'язкове",
    "Field is required": "Поле обов'язково для заповнення",
    "I will use Uku to work together with two or more teammates.": "Я буду використовувати Uku для спільної роботи з двома або більше товаришами по команді.",
    "I will use Uku by myself. This plan is free, but the features are limited.": "Я буду використовувати Уку сам. Цей план безкоштовний, але його функції обмежені.",
    "Media": "Медіа",
    "Through integration partner": "Через інтеграційного партнера",
    "Referral by friend": "Рекомендація другом",
    "Import speeds up your clients setup, smart choice!": "Імпорт прискорює налаштування ваших клієнтів, розумний вибір!",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} client": "Останній імпорт: додано {0}, оновлено {1}, пропущено {2}, не вдалося імпортувати {3} клієнт",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} clients": "Останній імпорт: додано {0}, оновлено {1}, пропущено {2}, не вдалося імпортувати {3} клієнтів",
    "Last import: added {0}, updated {1}, skipped {2}": "Останній імпорт: додано {0}, оновлено {1}, пропущено {2}",
    "What's next? Correct the data of {0} clients and upload again.": "Що далі? Виправте дані {0} клієнтів і завантажте знову.",
    "failed_to_import.xlsx": "failed_to_import.xlsx",
    "Excel (XLS, XLSX) ": "Excel (XLS, XLSX) ",
    "Instead of entering clients one by one, you can use file import for a large customer base.": "Замість того, щоб вводити клієнтів по одному, ви можете використовувати імпорт файлів для великої клієнтської бази.",
    "Ignore": "Ігнорувати",
    "NEW CLIENT": "НОВИЙ КЛІЄНТ",
    "Preview": "Перегляд",
    "Import started": "Імпорт розпочато",
    "Only new clients": "Тільки нові клієнти",
    "Update data from company register": "Оновлення даних з реєстру компаній",
    "If switched on, the company data is updated using the local business register": "Якщо ввімкнено, дані компанії оновлюються за допомогою місцевого реєстру підприємств",
    "We did not find a match in Äriregister": "Ми не знайшли пару в Äriregister",
    "We did not find a match in Companies House": "Ми не знайшли пари в Companies House",
    "No integration yet": "Інтеграції поки що немає",
    "Uku match": "Матч Уку",
    "Business register nr.": "Реєстр підприємств No",
    "Company register": "Реєстр компаній",
    "Upload file": "Завантажити файл",
    "Before uploading your file": "Перед завантаженням файлу",
    "Learn Uku’s data structure": "Вивчіть структуру даних Uku",
    "Download and use our sample file to see exactly how we organize data in Uku": "Завантажте та скористайтеся нашим прикладом файлу, щоб побачити, як саме ми організовуємо дані в Uku",
    "Download Client Import Example": "Завантажити приклад імпорту клієнта",
    "Download Contact Import Example": "Завантажити приклад імпорту контактів",
    "Fill in fields": "Заповніть поля",
    "The only mandatory field is the company name. Make sure you've filled out all the necessary fields before uploading the file.": "Єдине обов'язкове поле – назва компанії. Переконайтеся, що ви заповнили всі необхідні поля перед завантаженням файлу.",
    "Learn more about mandatory fields": "Докладніше про обов'язкові поля",
    "Create custom fields": "Створення настроюваних полів",
    "Some data fields may not be present by default. Make sure you create these custom fields before importing your data.": "Деякі поля даних можуть бути відсутніми за замовчуванням. Обов'язково створіть ці настроювані поля перед імпортом даних.",
    "Add new custom fields": "Додавання нових кастомних полів",
    "...or drag a file here": "... або перетягніть файл сюди",
    "Only Excel (.xls, .xlsx) file types are supported": "Підтримуються лише типи файлів Excel (.xls, .xlsx)",
    "Mapping": "Відображення",
    "First row is a header": "Перший рядок - заголовок",
    "Add field to all clients": "Додати поле для всіх клієнтів",
    "Add client group": "Додати групу клієнтів",
    "Fields for all clients": "Поля для всіх клієнтів",
    "Import of {0} in progress": "Триває імпорт {0}",
    "Import in progress": "Триває імпорт",
    "It may take some time. You can do other activities in Uku at the same time, we will let you know when it is ready.": "Це може зайняти деякий час. Ви можете одночасно займатися іншими видами діяльності в Уку, ми повідомимо вам, коли він буде готовий.",
    "Cancel import": "Скасувати імпорт",
    "Are you sure you want to cancel import?": "Ви впевнені, що хочете скасувати імпорт?",
    "Last updated": "Останнє оновлення",
    "Contracts": "Контракти",
    "Job name": "Найменування посади",
    "Workflow name": "Ім'я робочого процесу",
    "Details": "Подробиці",
    "Select jobs": "Оберіть вакансії",
    "Select task plan": "Вибір плану завдань",
    "of existing client": "існуючого клієнта",
    "You can also choose": "Ви також можете вибрати",
    "existing client tasks plan": "План завдань існуючого клієнта",
    "existing predefined jobs": "Існуючі попередньо визначені вакансії",
    "create a new plan": "Як створити новий план",
    "Select workflow": "Виберіть робочий процес",
    "existing project workflow": "Існуючий документообіг проекту",
    "existing workflow": "існуючий документообіг",
    "create a new workflow": "Створення нового робочого процесу",
    "New tasks template": "Новий шаблон завдань",
    "to save template!": "Щоб зберегти шаблон!",
    "You can also add tasks from jobs": "Ви також можете додавати завдання із завдань",
    "or choose": "або виберіть",
    "New workflow template": "Новий шаблон робочого процесу",
    "You can also add tasks from existing workflow templates": "Ви також можете додавати завдання з наявних шаблонів робочих процесів",
    "existing event workflow": "Існуючий робочий процес події",
    "Hide others": "Приховування інших",
    "Update all events (New tasks)": "Оновити всі події (Нові завдання)",
    "Update all projects (New tasks)": "Оновити всі проекти (Нові завдання)",
    "Once": "Одного разу",
    "Once a month": "Раз на місяць",
    "Once a quarter": "Раз на квартал",
    "Once a year": "Раз на рік",
    "Company workflow": "Документообіг компанії",
    "Company jobs": "Вакансії в компанії",
    "Default jobs": "Завдання за замовчуванням",
    "ID": "ID",
    "Task title and labels": "Назва завдання та мітки",
    "Assigned and time": "Призначення і час",
    "Setup tasks for {0} event": "Налаштування завдань для {0} події",
    "Setup tasks for {0} project": "Налаштування завдань для {0} проекту",
    "New job": "Нова робота",
    "Edit job": "Редагувати завдання",
    "New workflow": "Новий робочий процес",
    "Save workflow": "Збереження робочого процесу",
    "Confirm task plan": "Підтвердіть план завдання",
    "Skip": "Пропустити",
    "Create task plan": "Створення плану завдань",
    "Edit task plan": "Edit task plan",
    "Confirm workflow": "Підтвердьте робочий процес",
    "Client portal templates": "Шаблони клієнтських порталів",
    "Jobs": "Вакансії",
    "Workflows": "Робочі процеси",
    "Company workflows": "Робочі процеси компанії",
    "Default workflows": "Робочі процеси за замовчуванням",
    "Company template saved": "Шаблон компанії збережено",
    "Company template created": "Створено шаблон компанії",
    "Format": "Формат",
    "Currency": "Валюта",
    "Reference number": "Реєстраційний номер",
    "Invoice description": "Опис рахунку-фактури",
    "Summarize invoice rows": "Підсумовування рядків рахунків-фактур",
    "Summarized description": "Узагальнений опис",
    "Reverse charge": "Зворотна зарядка",
    "Rounding": "Округлення",
    "Time rounding will apply for each line": "Для кожного рядка застосовуватиметься округлення часу",
    "Rounding increment (up)": "Крок округлення (вгору)",
    "Reply to": "Відповісти",
    "Configuration": "Конфігурація",
    "Invoice to parent company": "Рахунок-фактура материнській компанії",
    "Create all invoices under parent company.": "Створіть усі рахунки-фактури під материнською компанією.",
    "User code": "Код користувача",
    "Default": "За замовчуванням",
    "Default value will apply for each line": "Значення за замовчуванням буде застосовуватися до кожного рядка",
    "Number": "Номер",
    "You can write any of the following in curly braces to invoice prefix field. When saving the contract the prefix is filled with the corresponding value.": "Ви можете написати будь-що з наведеного нижче у фігурних дужках у поле префікса рахунку-фактури. При збереженні договору префікс заповнюється відповідним значенням.",
    "Copy to clipboard": "Копіювати до буфера обміну",
    "Invoice previous period": "Рахунок-фактура за попередній період",
    "Invoice period": "Період виставлення рахунка-фактури",
    "Invoice next period": "Рахунок-фактура в наступному періоді",
    "Client primary user": "Основний користувач клієнта",
    "Original client name": "Оригінальне ім'я клієнта",
    "invoice date year": "дата рахунка-фактури, рік",
    "last two digits of invoice date year": "останні дві цифри дати рахунка-фактури рік",
    "invoice date month": "дата рахунка-фактури, місяць",
    "invoice date day": "Дата виставлення рахунка-фактури, день",
    "Contract": "Контракт",
    "Net total": "Net total",
    "Contract #": "Контракт #",
    "Invoice #": "Рахунок-фактура #",
    "Exported": "Експортовано",
    "Sent": "Відправленно",
    "Net": "Нетто",
    "Add invoice": "Додати рахунок",
    "Change invoice number": "Змінити номер рахунка-фактури",
    "Review changes": "Переглянути зміни",
    "Please review and approve changes to the related events": "Будь ласка, перегляньте та схваліть зміни до пов'язаних подій",
    "Please review and approve changes to the related projects": "Будь ласка, перегляньте та затвердіть зміни до пов'язаних проєктів",
    "Contains": "Містить",
    "contains": "містить",
    "Exactly": "Точно",
    "is exactly": "є саме",
    "Greater than": "Більше ніж",
    "is greater than": "більше, ніж",
    "Less than": "Менше ніж",
    "is less than": "менше ніж",
    "Range": "Діапазон",
    "is in range of": "знаходиться в діапазоні",
    "is empty": "порожній",
    "Task plan": "План завдань",
    "Edit plan": "Редагувати план",
    "Use task plan templates to set up tasks effectively or add a task manually": "Використовуйте шаблони планів завдань для ефективного налаштування завдань або додавайте завдання вручну",
    "Add task manually": "Додавання завдання вручну",
    "Quarterly": "Поквартально",
    "Export excel": "Експорт Excel",
    "Print PDF": "Друк у форматі PDF",
    "Edit jobs": "Редагування вакансій",
    "Replace plan tasks with job": "Замініть завдання плану завданнями на роботу",
    "Select template": "Виберіть шаблон",
    "member": "учасник",
    "Tasks with user will be added to every selected client": "Завдання з користувачем будуть додані до кожного обраного клієнта",
    "Add even if job already applied": "Додайте, навіть якщо завдання вже застосовано",
    "Default user": "Користувач за замовчуванням",
    "This will delete all tasks from client plan and put only selected template’s tasks in it": "Це видалить усі завдання з клієнтського плану та помістить у нього лише вибрані завдання шаблону",
    "Adding template will be ready in a minute. You can continue with work.": "Додавання шаблону буде готове за хвилину. Можна продовжувати роботу.",
    "Add client": "Додати клієнта",
    "Export clients": "Експорт клієнтів",
    "Export client contacts": "Експорт контактів клієнта",
    "client | clients": "клієнт | Клієнтів",
    "clients": "Клієнтів",
    "client(s) had errors": "У клієнта (клієнтів) були помилки",
    "client(s) selected": "Обрано клієнта (клієнтів)",
    "Contract actions": "Дії за договором",
    "Edit Members": "Редагувати учасників",
    "Edit monitoring": "Моніторинг редагувань",
    "Your company": "Ваша компанія",
    "Edit billing": "Як змінити платіж",
    "Activate client portal": "Активувати клієнтський портал",
    "After activation, you can send tasks directly to all client's contacts who have an e-mail address.": "Після активації ви можете надсилати завдання безпосередньо всім контактам клієнта, які мають адресу електронної пошти.",
    "Send welcome invitation to client contacts": "Надішліть вітальне запрошення контактам клієнтів",
    "Who will receive an invitation?": "Хто отримає запрошення?",
    "Client contact who has one valid e-mail address": "Контактна особа клієнта, яка має одну дійсну адресу електронної пошти",
    "Client contact who has the client's portal open (default for all)": "Контактна особа клієнта, у якого відкрито портал клієнта (за замовчуванням для всіх)",
    "How does the invitation work?": "Як працює запрошення?",
    "Uku creates and sends a 'Welcome task' to each client contact. It's created by the client primary user based on the 'Welcome to the Customer Portal' task template. Check it out under your company task templates. It will be translated according to the contact language.": "Uku створює та надсилає «Вітальне завдання» кожному контакту клієнта. Він створюється основним користувачем клієнта на основі шаблону завдання \"Ласкаво просимо на портал клієнта\". Перевірте це в шаблонах завдань вашої компанії. Вона буде перекладена відповідно до контактної мови.",
    "Uku client portal always informs clients by email about new tasks.": "Клієнтський портал Uku завжди інформує клієнтів по електронній пошті про нові завдання.",
    "View templates": "Переглянути шаблони",
    "Client portal activated": "Клієнтський портал активовано",
    "Company's name": "Назва компанії",
    "Mark": "Виділити",
    "Add members": "Додати учасників",
    "Members and groups": "Учасники та групи",
    "Topic is required": "Тема обов'язкова для заповнення",
    "Entering time is required": "Час введення обов'язковий",
    "Delete client": "Видалити клієнта",
    "Manage client fields": "Керування полями клієнта",
    "Max 3 characters": "Максимум 3 символи",
    "Are you sure you wish to delete this client?": "Ви впевнені, що хочете видалити цього клієнта?",
    "Deleting client data will also delete all client-related tasks.<br/><br/>NB! Client history will be deleted": "Видалення даних клієнта також призведе до видалення всіх завдань, пов'язаних із клієнтом.<br/><br/>Важливо! Історія клієнта буде видалена",
    "Owner": "Власник",
    "All clients that you add under {0} will be deleted later.</div>": "Усі клієнти, які ви додасте до розділу {0} , буде видалено пізніше.",
    "Use this account for testing purposes only!": "Використовуйте цей обліковий запис лише для тестування!",
    "Read more about the demo account": "Детальніше про демо-рахунок",
    "Rights": "Права",
    "Monitoring setup": "Налаштування моніторингу",
    "Learn more about monitoring": "Дізнатися більше про моніторинг",
    "selected": "вибрано",
    "Resend": "Resend",
    "Invoicing": "Фактур",
    "Billing template": "Шаблон білінгу",
    "New": "Новий",
    "Add row": "Додати рядок",
    "Delete contract": "Видалити договір",
    "Product / description": "Товар / опис",
    "Qty": "Кількість",
    "Product placeholders": "Заповнювачі товарів",
    "You can write any of the following lines in curly brackets to product description. When saving an invoice it will replace the text with the corresponding value.": "You can write any of the following lines in curly brackets to product description. When saving an invoice it will replace the text with the corresponding value.",
    "Template saved": "Шаблон збережено",
    "Warning": "Увага",
    "Would you like to apply these changes to all clients using this contract template?": "Чи хотіли б ви застосувати ці зміни до всіх клієнтів, які використовують цей шаблон договору?",
    "Yes, apply to all clients": "Так, застосовується до всіх клієнтів",
    "You have made changes to time period that this billing contract applies to. This may change how affected unbilled services in the past and future will be invoiced. Please confirm that this change was intentional.": "Ви внесли зміни до періоду часу, на який поширюється дія цього договору про виставлення рахунків. Це може змінити спосіб виставлення рахунків за невиставлені послуги, які постраждали в минулому та майбутньому. Будь ласка, підтвердьте, що ця зміна була навмисною.",
    "Are you sure to delete this template?": "Ви впевнені, що видалили цей шаблон?",
    "Save template": "Зберегти шаблон",
    "Save as template": "Зберегти як Шаблон",
    "Please note all changes made to contract will be lost": "Будь ласка, зверніть увагу, що всі зміни, внесені до договору, будуть втрачені",
    "Add contract": "Додати договір",
    "Manage contract templates": "Керування шаблонами договорів",
    "Edit account details": "Як змінити реквізити облікового запису",
    "Country is required": "Країна є обов'язковою",
    "Postal code": "Почтовий код",
    "State": "Область",
    "Uku is set up according to the field of work.": "Уку налаштовується відповідно до сфери діяльності.",
    "Size of the team": "Розмір команди",
    "Website": "Website",
    "Delete account": "Видалити аккаунт",
    "Deleting an account will also delete all clients associated with the account, their tasks, and their entire history. Are you sure that you want to delete your account?": "Видалення облікового запису також призведе до видалення всіх клієнтів, пов'язаних з обліковим записом, їхніх завдань і всієї історії. Ви впевнені, що хочете видалити свій обліковий запис?",
    "Yes, delete the account with all related data such as clients, tasks, and all history": "Так, видаліть обліковий запис з усіма пов'язаними даними, такими як клієнти, завдання та вся історія",
    "These invoices cannot be sent. Check their status or error messages.": "Ці рахунки-фактури не можна надіслати. Перевірте їх статус або повідомлення про помилки.",
    "Please confirm that you wish to proceed.": "Будь ласка, підтвердьте, що ви бажаєте продовжити.",
    "Sending invoice | Sending invoices": "Відправка рахунку-фактури | Надсилання рахунків-фактур",
    "You are about to e-mail this invoice to customer. | You are about to e-mail these invoices to customers.": "Ви збираєтеся надіслати цей рахунок-фактуру електронною поштою клієнту. | Ви збираєтеся надіслати ці рахунки-фактури клієнтам електронною поштою.",
    "Error in calculating invoice": "Помилка при розрахунку рахунку-фактури",
    "Error in importing invoice": "Помилка при імпорті рахунку-фактури",
    "Error in creating invoice": "Помилка при створенні рахунку-фактури",
    "Error in exporting invoice": "Помилка при експорті рахунку-фактури",
    "Error in sending invoice": "Помилка при відправці рахунку-фактури",
    "Calculating invoice": "Розрахунок рахунку-фактури",
    "Creating invoice": "Створення інвойсу",
    "Exporting invoice": "Експорт інвойсу",
    "Importing invoice": "Імпорт інвойсу",
    "Sending invoice": "Відправка рахунку-фактури",
    "Clear errors": "Усунення помилок",
    "Related work will be made billable again. The invoices will not be deleted from external systems, you will have to do that manually.": "Пов'язані з цим роботи знову будуть оплачуватися. Рахунки-фактури не будуть видалені із зовнішніх систем, вам доведеться робити це вручну.",
    "Delete invoice | Deleting invoices": "Видалити рахунок-фактуру | Видалення рахунків-фактур",
    "Selected net total": "Selected net total",
    "Nothing in invoices": "Нічого в рахунках-фактурах",
    "Please make sure you have setup recurring billing for your clients": "Будь ласка, переконайтеся, що ви налаштували регулярне виставлення рахунків для своїх клієнтів",
    "Draft": "Чернетка",
    "Approval": "Схвалення",
    "Created": "Створено",
    "Coming soon": "Скоро буде",
    "Selected invoices and related product info will be sent to accounting system.": "Вибрані рахунки-фактури та пов'язана з ними інформація про товар будуть надіслані до облікової системи.",
    "Piece": "Шматочок",
    "Hour": "Година",
    "Delete row": "Видалити рядок",
    "Out of ": "З ",
    " can be created": " можна створити",
    "For ": "Для ",
    " invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": " Період виставлення рахунків все ще триває. Будь-яка робота, виконана в цей період після створення рахунку-фактури, не буде виставлена в рахунок.",
    "Invoice date will be set to today.": "Дату виставлення рахунка буде встановлено на сьогодні.",
    "Uku is about to create": "Uku збирається створити",
    " selected row, only | selected row, only ": " вибраний рядок, лише | вибраний рядок, тільки ",
    " invoice | invoices": " рахунок-фактура | Рахунків",
    "These invoices cannot be exported. Check their status or error messages.": "Ці рахунки-фактури не можна експортувати. Перевірте їх статус або повідомлення про помилки.",
    "Exporting invoice | Exporting invoices": "Експорт рахунку-фактури | Експорт рахунків-фактур",
    "You are about to export this invoice to accounting. | You are about to export these invoices to accounting.": "Ви збираєтеся експортувати цей рахунок-фактуру до бухгалтерії. | Ви збираєтеся експортувати ці рахунки-фактури до бухгалтерії.",
    "This invoice has already been exported. Are you sure you want to export it as a new invoice? | Some of these invoices have already been exported. Are you sure that you want to export them as new invoices?": "This invoice has already been exported. Are you sure you want to export it as a new invoice? | Some of these invoices have already been exported. Are you sure that you want to export them as new invoices?",
    "Download pdf": "Завантажити pdf",
    "Create invoice": "Створити рахунок-фактуру",
    "Update status from {0}": "Статус оновлення з {0}",
    "Show all lines": "Показати всі рядки",
    "Calculate invoice": "Розрахувати рахунок-фактуру",
    "Loading invoice...": "Завантаження рахунку-фактури...",
    "Invalid Scoro credentials": "Недійсні облікові дані Scoro",
    "Please confirm the changes you have made to this invoice.": "Будь ласка, підтвердьте зміни, які ви внесли до цього рахунку-фактури.",
    "NB! Note that changed invoice will not be automatically sent to customer or exported to external systems - you will have to do this manually.": "Важливо! Зверніть увагу, що змінений рахунок-фактура не буде автоматично відправлений клієнту або експортований в зовнішні системи - вам доведеться робити це вручну.",
    "Invoice number already exists! Please confirm to save anyway.": "Номер рахунку-фактури вже існує! Будь ласка, підтвердьте, щоб зберегти в будь-якому випадку.",
    "Error in data": "Помилка в даних",
    "The invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": "Період виставлення рахунків все ще триває. Будь-яка робота, виконана в цей період після створення рахунку-фактури, не буде виставлена в рахунок.",
    "Creation date": "Дата створення",
    "{0} days after": "{0} днів після",
    "{0} day after": "{0} день після",
    "right away when": "відразу, коли",
    "start date": "Дата початку",
    "due date": "Термін виконання",
    "finished": "Закінчили",
    "Entries count": "Кількість записів",
    "Entries excluding sales": "Записи без урахування продажів",
    "Entries excluding bank": "Записи без урахування банку",
    "Entries excluding documents": "Записи без документів",
    "Documents (sales and purchases)": "Документи (купівлі-продажі)",
    "Cash entries": "Грошові записи",
    "VAT entries": "Записи з ПДВ",
    "Stock entries": "Записи на складі",
    "Sale entries": "Записи про продаж",
    "Purchase entries": "Записи про купівлю",
    "Bank entries": "Банківські записи",
    "Ledger entries": "Записи в бухгалтерській книзі",
    "Depreciation entries": "Амортизаційні проводки",
    "Entry lines count": "Кількість вхідних рядків",
    "Transaction create": "Transaction create",
    "Transaction update": "Transaction update",
    "Purchase invoice create": "Purchase invoice create",
    "Purchase invoice update": "Purchase invoice update",
    "Sales invoice create": "Sales invoice create",
    "Sales invoice update": "Sales invoice update",
    "Financial entry create": "Financial entry create",
    "Financial entry update": "Financial entry update",
    "Expense row create": "Expense row create",
    "Expense row update": "Expense row update",
    "Depreciation create": "Depreciation create",
    "Depreciation update": "Depreciation update",
    "Person count": "Person count",
    "Fixed assets": "Fixed assets",
    "Company owner": "Власник компанії",
    "Activity": "Активність",
    "Oldest first": "Спочатку найстаріші",
    "Newest first": "Спочатку новіші",
    "Quantity as time": "Кількість у часі",
    "Quantity as number": "Кількість як число",
    "Quantity as time in number format": "Кількість як час у числовому форматі",
    "No rounding": "Без округлення",
    "min": "мін",
    "hour": "година",
    "Last day of month": "Останній день місяця",
    "Invoice line": "Рядок інвойсу",
    "Task time total (per member)": "Загальний час виконання завдання (на одного учасника)",
    "Time entry": "Введення часу",
    "Task finish date": "Дата завершення завдання",
    "Create separately": "Створюйте окремо",
    "Merge into one": "Об'єднати в одне ціле",
    "No minimum": "Немає мінімума",
    "{0} minute": "{0} хвилина",
    "{0} minutes": "{0} хвилин",
    "{0} hour": "{0} годину",
    "{0} hours": "{0} годин",
    "English": "Англійська",
    "Estonian": "Estonian",
    "Danish": "датська",
    "Lithuanian": "Lithuanian",
    "Russian": "Російська",
    "Finnish": "Фінська",
    "Swedish": "шведська",
    "Norwegian": "Норвезький",
    "Latvian": "Latvian",
    "Bulgarian": "болгарська",
    "German": "Німецька",
    "Spanish": "Іспанська",
    "Polish": "Глянцева",
    "Field: ": "Поле: ",
    "Normal hours": "Звичайний графік роботи",
    "Year": "Рік",
    "Estonia": "Естонія",
    "Finland": "Фінляндія",
    "Poland": "Польша",
    "User": "Користувач",
    "None": "Немає",
    "Error!": "Помилка!",
    "Pending": "В очікуванні",
    "Finished": "Завершено",
    "Text": "Текст",
    "Choice": "Вибір",
    "Yes/No": "Так/Ні",
    "Integer": "Ціле число",
    "Multiple choice": "Широкий вибір",
    "URL": "URL",
    "Multiple users": "Кілька користувачів",
    "Multiline text": "Багаторядковий текст",
    "Must be a integer": "Має бути цілим числом",
    "Must be a date": "Має бути дата",
    "Must be a valid e-mail address": "Має бути дійсною адресою електронної пошти",
    "Unknown choice": "Невідомий вибір",
    "Some errors occurred:": "Сталися деякі помилки:",
    "Unknown network error": "Невідома помилка мережі",
    "Could not connect to the service": "Не вдалося підключитися до сервісу",
    "Reload this page": "Перезавантажити цю сторінку",
    "Invoice paid": "Рахунок-фактуру сплачено",
    "Annulled": "Анульовано",
    "Processing": "В обробці",
    "You are about to deactivate this app.": "Ви збираєтеся деактивувати цю програму.",
    "You are about to disconnect this app.": "Ви збираєтеся відключити цю програму.",
    "Do you also want to activate billing to get the most out of Uku?": "Ви також хочете активувати білінг, щоб отримати максимальну віддачу від Uku?",
    "Invoice": "Рахунок-фактура",
    "Clients - Monitoring": "Клієнти - Моніторинг",
    "Links": "Посилання",
    "New template": "Новий шаблон",
    "Import Clients from Excel": "Імпорт клієнтів з Excel",
    "Importer": "Імпортера",
    "Import clients from Excel": "Імпорт клієнтів з Excel",
    "Account settings": "Налаштування облікового запису",
    "Empty": "Порожньо",
};
export default translations